// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Afacad:wght@400;500;600&family=Golos+Text:wght@400;600&family=Outfit:wght@300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(147 197 253 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop{
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(147 197 253 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: rgb(var(--tw-gray-200, 229 231 235) / 1); /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: Outfit, Inter, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: JetBrains Mono, Fira Code, Consolas, monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: rgb(var(--tw-gray-400, 156 163 175) / 1); /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  html {
    font-family: var(--theme-font-family, 'Outfit', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif);
    text-rendering: geometricPrecision;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-white, 255 255 255) / var(--tw-bg-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-text-primary, 31 41 55) / var(--tw-text-opacity, 1));
    font-feature-settings: 'cv02', 'cv03', 'cv04', 'cv11';
}

  *:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--agentic-primary-blue, 30 58 138) / var(--tw-ring-opacity, 1));
  --tw-ring-offset-width: 2px;
}

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-track{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-gray-100, 243 244 246) / var(--tw-bg-opacity, 1));
}

  ::-webkit-scrollbar-thumb{
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-gray-300, 209 213 219) / var(--tw-bg-opacity, 1));
}

  ::-webkit-scrollbar-thumb:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-gray-400, 156 163 175) / var(--tw-bg-opacity, 1));
}
.\\!container{
  width: 100% !important;
}
.container{
  width: 100%;
}
@media (min-width: 375px){

  .\\!container{
    max-width: 375px !important;
  }

  .container{
    max-width: 375px;
  }
}
@media (min-width: 640px){

  .\\!container{
    max-width: 640px !important;
  }

  .container{
    max-width: 640px;
  }
}
@media (min-width: 768px){

  .\\!container{
    max-width: 768px !important;
  }

  .container{
    max-width: 768px;
  }
}
@media (min-width: 1024px){

  .\\!container{
    max-width: 1024px !important;
  }

  .container{
    max-width: 1024px;
  }
}
@media (min-width: 1280px){

  .\\!container{
    max-width: 1280px !important;
  }

  .container{
    max-width: 1280px;
  }
}
@media (min-width: 1440px){

  .\\!container{
    max-width: 1440px !important;
  }

  .container{
    max-width: 1440px;
  }
}
@media (min-width: 1536px){

  .\\!container{
    max-width: 1536px !important;
  }

  .container{
    max-width: 1536px;
  }
}

  .page-subtitle{
  margin-top: 0.5rem;
  max-width: 48rem;
  font-size: 1.125rem;
  line-height: 1.625;
  --tw-text-opacity: 1;
  color: rgb(var(--kv-agentic-slate, 65 71 77) / var(--tw-text-opacity, 1));
}

  .section-title{
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 600;
  line-height: 1.25;
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-text-primary, 31 41 55) / var(--tw-text-opacity, 1));
}

  .tab-title{
  border-bottom-width: 2px;
  border-color: transparent;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-text-secondary, 107 114 128) / var(--tw-text-opacity, 1));
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

  .tab-title:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--agentic-gray-300, 209 213 219) / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-text-primary, 31 41 55) / var(--tw-text-opacity, 1));
}

  .tab-title-active{
  --tw-border-opacity: 1;
  border-color: rgb(var(--agentic-primary-blue, 30 58 138) / var(--tw-border-opacity, 1));
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-primary-blue, 30 58 138) / var(--tw-text-opacity, 1));
}

  .tab-content-panel{
  border-radius: 1.5rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--agentic-gray-200, 229 231 235) / var(--tw-border-opacity, 1));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

  .loading-spinner{
  height: 1.5rem;
  width: 1.5rem;
}

  @keyframes spin{

  to{
    transform: rotate(360deg);
  }
}

  .loading-spinner{
  animation: spin 1s linear infinite;
  border-radius: 9999px;
  border-bottom-width: 2px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--agentic-primary-blue, 30 58 138) / var(--tw-border-opacity, 1));
}
.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none{
  pointer-events: none;
}
.pointer-events-auto{
  pointer-events: auto;
}
.\\!visible{
  visibility: visible !important;
}
.visible{
  visibility: visible;
}
.static{
  position: static;
}
.fixed{
  position: fixed;
}
.absolute{
  position: absolute;
}
.relative{
  position: relative;
}
.sticky{
  position: sticky;
}
.inset-0{
  inset: 0px;
}
.inset-x-0{
  left: 0px;
  right: 0px;
}
.inset-y-0{
  top: 0px;
  bottom: 0px;
}
.-bottom-28{
  bottom: -7rem;
}
.-left-10{
  left: -2.5rem;
}
.-left-16{
  left: -4rem;
}
.-left-24{
  left: -6rem;
}
.-left-3{
  left: -0.75rem;
}
.-left-5{
  left: -1.25rem;
}
.-left-\\[13\\.8\\%\\]{
  left: -13.8%;
}
.-left-\\[176px\\]{
  left: -176px;
}
.-left-\\[296px\\]{
  left: -296px;
}
.-left-\\[38px\\]{
  left: -38px;
}
.-left-\\[4\\%\\]{
  left: -4%;
}
.-left-\\[62px\\]{
  left: -62px;
}
.-left-\\[8\\%\\]{
  left: -8%;
}
.-right-3{
  right: -0.75rem;
}
.-right-5{
  right: -1.25rem;
}
.-right-\\[31\\.2\\%\\]{
  right: -31.2%;
}
.-right-\\[38\\%\\]{
  right: -38%;
}
.-top-10{
  top: -2.5rem;
}
.-top-24{
  top: -6rem;
}
.-top-3{
  top: -0.75rem;
}
.-top-4{
  top: -1rem;
}
.-top-\\[320px\\]{
  top: -320px;
}
.bottom-0{
  bottom: 0px;
}
.bottom-10{
  bottom: 2.5rem;
}
.bottom-24{
  bottom: 6rem;
}
.bottom-4{
  bottom: 1rem;
}
.bottom-\\[22px\\]{
  bottom: 22px;
}
.left-0{
  left: 0px;
}
.left-1\\/2{
  left: 50%;
}
.left-3{
  left: 0.75rem;
}
.left-4{
  left: 1rem;
}
.left-\\[5\\.5\\%\\]{
  left: 5.5%;
}
.right-0{
  right: 0px;
}
.right-10{
  right: 2.5rem;
}
.right-16{
  right: 4rem;
}
.right-2{
  right: 0.5rem;
}
.right-3{
  right: 0.75rem;
}
.right-4{
  right: 1rem;
}
.right-5{
  right: 1.25rem;
}
.right-8{
  right: 2rem;
}
.right-\\[-25\\%\\]{
  right: -25%;
}
.right-\\[-28\\%\\]{
  right: -28%;
}
.right-\\[-60px\\]{
  right: -60px;
}
.right-\\[calc\\(24\\.05\\%-26px\\)\\]{
  right: calc(24.05% - 26px);
}
.top-0{
  top: 0px;
}
.top-1{
  top: 0.25rem;
}
.top-1\\/2{
  top: 50%;
}
.top-2{
  top: 0.5rem;
}
.top-20{
  top: 5rem;
}
.top-3{
  top: 0.75rem;
}
.top-4{
  top: 1rem;
}
.top-40{
  top: 10rem;
}
.top-6{
  top: 1.5rem;
}
.top-8{
  top: 2rem;
}
.top-\\[108px\\]{
  top: 108px;
}
.top-\\[120px\\]{
  top: 120px;
}
.top-\\[16\\%\\]{
  top: 16%;
}
.top-\\[24\\%\\]{
  top: 24%;
}
.top-\\[252px\\]{
  top: 252px;
}
.top-\\[27\\%\\]{
  top: 27%;
}
.top-\\[36\\%\\]{
  top: 36%;
}
.top-\\[384px\\]{
  top: 384px;
}
.top-\\[40\\%\\]{
  top: 40%;
}
.top-\\[45px\\]{
  top: 45px;
}
.top-\\[46\\%\\]{
  top: 46%;
}
.top-\\[52\\%\\]{
  top: 52%;
}
.top-\\[56\\%\\]{
  top: 56%;
}
.top-\\[66\\%\\]{
  top: 66%;
}
.top-\\[74\\%\\]{
  top: 74%;
}
.top-\\[76\\%\\]{
  top: 76%;
}
.top-full{
  top: 100%;
}
.isolate{
  isolation: isolate;
}
.z-0{
  z-index: 0;
}
.z-10{
  z-index: 10;
}
.z-20{
  z-index: 20;
}
.z-30{
  z-index: 30;
}
.z-40{
  z-index: 40;
}
.z-50{
  z-index: 50;
}
.z-\\[45\\]{
  z-index: 45;
}
.z-\\[60\\]{
  z-index: 60;
}
.z-\\[9999\\]{
  z-index: 9999;
}
.z-\\[999\\]{
  z-index: 999;
}
.col-span-1{
  grid-column: span 1 / span 1;
}
.col-span-10{
  grid-column: span 10 / span 10;
}
.col-span-12{
  grid-column: span 12 / span 12;
}
.col-span-2{
  grid-column: span 2 / span 2;
}
.col-span-3{
  grid-column: span 3 / span 3;
}
.col-span-4{
  grid-column: span 4 / span 4;
}
.col-span-5{
  grid-column: span 5 / span 5;
}
.col-span-full{
  grid-column: 1 / -1;
}
.m-1{
  margin: 0.25rem;
}
.m-4{
  margin: 1rem;
}
.-mx-6{
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}
.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-6{
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}
.mx-auto{
  margin-left: auto;
  margin-right: auto;
}
.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.-mb-px{
  margin-bottom: -1px;
}
.mb-0{
  margin-bottom: 0px;
}
.mb-1{
  margin-bottom: 0.25rem;
}
.mb-1\\.5{
  margin-bottom: 0.375rem;
}
.mb-2{
  margin-bottom: 0.5rem;
}
.mb-2\\.5{
  margin-bottom: 0.625rem;
}
.mb-3{
  margin-bottom: 0.75rem;
}
.mb-4{
  margin-bottom: 1rem;
}
.mb-5{
  margin-bottom: 1.25rem;
}
.mb-6{
  margin-bottom: 1.5rem;
}
.mb-8{
  margin-bottom: 2rem;
}
.ml-0\\.5{
  margin-left: 0.125rem;
}
.ml-1{
  margin-left: 0.25rem;
}
.ml-1\\.5{
  margin-left: 0.375rem;
}
.ml-14{
  margin-left: 3.5rem;
}
.ml-2{
  margin-left: 0.5rem;
}
.ml-3{
  margin-left: 0.75rem;
}
.ml-4{
  margin-left: 1rem;
}
.ml-6{
  margin-left: 1.5rem;
}
.ml-7{
  margin-left: 1.75rem;
}
.ml-8{
  margin-left: 2rem;
}
.ml-auto{
  margin-left: auto;
}
.mr-1{
  margin-right: 0.25rem;
}
.mr-1\\.5{
  margin-right: 0.375rem;
}
.mr-2{
  margin-right: 0.5rem;
}
.mr-4{
  margin-right: 1rem;
}
.mt-0\\.5{
  margin-top: 0.125rem;
}
.mt-1{
  margin-top: 0.25rem;
}
.mt-1\\.5{
  margin-top: 0.375rem;
}
.mt-10{
  margin-top: 2.5rem;
}
.mt-12{
  margin-top: 3rem;
}
.mt-14{
  margin-top: 3.5rem;
}
.mt-16{
  margin-top: 4rem;
}
.mt-2{
  margin-top: 0.5rem;
}
.mt-2\\.5{
  margin-top: 0.625rem;
}
.mt-3{
  margin-top: 0.75rem;
}
.mt-4{
  margin-top: 1rem;
}
.mt-5{
  margin-top: 1.25rem;
}
.mt-6{
  margin-top: 1.5rem;
}
.mt-7{
  margin-top: 1.75rem;
}
.mt-8{
  margin-top: 2rem;
}
.mt-\\[23px\\]{
  margin-top: 23px;
}
.mt-auto{
  margin-top: auto;
}
.line-clamp-1{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.line-clamp-3{
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
}
.block{
  display: block;
}
.inline-block{
  display: inline-block;
}
.inline{
  display: inline;
}
.flex{
  display: flex;
}
.inline-flex{
  display: inline-flex;
}
.table{
  display: table;
}
.grid{
  display: grid;
}
.hidden{
  display: none;
}
.aspect-video{
  aspect-ratio: 16 / 9;
}
.h-1{
  height: 0.25rem;
}
.h-1\\.5{
  height: 0.375rem;
}
.h-10{
  height: 2.5rem;
}
.h-11{
  height: 2.75rem;
}
.h-12{
  height: 3rem;
}
.h-14{
  height: 3.5rem;
}
.h-16{
  height: 4rem;
}
.h-2{
  height: 0.5rem;
}
.h-2\\.5{
  height: 0.625rem;
}
.h-20{
  height: 5rem;
}
.h-24{
  height: 6rem;
}
.h-3{
  height: 0.75rem;
}
.h-3\\.5{
  height: 0.875rem;
}
.h-4{
  height: 1rem;
}
.h-40{
  height: 10rem;
}
.h-5{
  height: 1.25rem;
}
.h-56{
  height: 14rem;
}
.h-6{
  height: 1.5rem;
}
.h-64{
  height: 16rem;
}
.h-7{
  height: 1.75rem;
}
.h-72{
  height: 18rem;
}
.h-8{
  height: 2rem;
}
.h-80{
  height: 20rem;
}
.h-9{
  height: 2.25rem;
}
.h-96{
  height: 24rem;
}
.h-\\[1001px\\]{
  height: 1001px;
}
.h-\\[100dvh\\]{
  height: 100dvh;
}
.h-\\[130px\\]{
  height: 130px;
}
.h-\\[140px\\]{
  height: 140px;
}
.h-\\[144px\\]{
  height: 144px;
}
.h-\\[1585px\\]{
  height: 1585px;
}
.h-\\[176px\\]{
  height: 176px;
}
.h-\\[184px\\]{
  height: 184px;
}
.h-\\[200px\\]{
  height: 200px;
}
.h-\\[204px\\]{
  height: 204px;
}
.h-\\[22px\\]{
  height: 22px;
}
.h-\\[300px\\]{
  height: 300px;
}
.h-\\[348px\\]{
  height: 348px;
}
.h-\\[40px\\]{
  height: 40px;
}
.h-\\[42px\\]{
  height: 42px;
}
.h-\\[440px\\]{
  height: 440px;
}
.h-\\[460px\\]{
  height: 460px;
}
.h-\\[462px\\]{
  height: 462px;
}
.h-\\[500px\\]{
  height: 500px;
}
.h-\\[52px\\]{
  height: 52px;
}
.h-\\[600px\\]{
  height: 600px;
}
.h-\\[60px\\]{
  height: 60px;
}
.h-\\[90vh\\]{
  height: 90vh;
}
.h-\\[969px\\]{
  height: 969px;
}
.h-\\[calc\\(100\\%-80px\\)\\]{
  height: calc(100% - 80px);
}
.h-\\[calc\\(100dvh-5\\.5rem\\)\\]{
  height: calc(100dvh - 5.5rem);
}
.h-\\[calc\\(100dvh-57px\\)\\]{
  height: calc(100dvh - 57px);
}
.h-auto{
  height: auto;
}
.h-fit{
  height: fit-content;
}
.h-full{
  height: 100%;
}
.h-px{
  height: 1px;
}
.h-screen{
  height: 100vh;
}
.\\!max-h-\\[94dvh\\]{
  max-height: 94dvh !important;
}
.max-h-40{
  max-height: 10rem;
}
.max-h-48{
  max-height: 12rem;
}
.max-h-52{
  max-height: 13rem;
}
.max-h-56{
  max-height: 14rem;
}
.max-h-60{
  max-height: 15rem;
}
.max-h-64{
  max-height: 16rem;
}
.max-h-72{
  max-height: 18rem;
}
.max-h-\\[24rem\\]{
  max-height: 24rem;
}
.max-h-\\[400px\\]{
  max-height: 400px;
}
.max-h-\\[40vh\\]{
  max-height: 40vh;
}
.max-h-\\[50vh\\]{
  max-height: 50vh;
}
.max-h-\\[70vh\\]{
  max-height: 70vh;
}
.max-h-\\[80vh\\]{
  max-height: 80vh;
}
.max-h-\\[85\\%\\]{
  max-height: 85%;
}
.max-h-\\[85vh\\]{
  max-height: 85vh;
}
.max-h-\\[90vh\\]{
  max-height: 90vh;
}
.max-h-\\[min\\(90dvh\\2c 900px\\)\\]{
  max-height: min(90dvh, 900px);
}
.min-h-0{
  min-height: 0px;
}
.min-h-20{
  min-height: 5rem;
}
.min-h-24{
  min-height: 6rem;
}
.min-h-5{
  min-height: 1.25rem;
}
.min-h-\\[100dvh\\]{
  min-height: 100dvh;
}
.min-h-\\[120px\\]{
  min-height: 120px;
}
.min-h-\\[224px\\]{
  min-height: 224px;
}
.min-h-\\[22px\\]{
  min-height: 22px;
}
.min-h-\\[300px\\]{
  min-height: 300px;
}
.min-h-\\[32rem\\]{
  min-height: 32rem;
}
.min-h-\\[40vh\\]{
  min-height: 40vh;
}
.min-h-\\[420px\\]{
  min-height: 420px;
}
.min-h-\\[430px\\]{
  min-height: 430px;
}
.min-h-\\[44px\\]{
  min-height: 44px;
}
.min-h-\\[48px\\]{
  min-height: 48px;
}
.min-h-\\[500px\\]{
  min-height: 500px;
}
.min-h-\\[520px\\]{
  min-height: 520px;
}
.min-h-\\[56px\\]{
  min-height: 56px;
}
.min-h-\\[60vh\\]{
  min-height: 60vh;
}
.min-h-\\[680px\\]{
  min-height: 680px;
}
.min-h-\\[80px\\]{
  min-height: 80px;
}
.min-h-\\[80vh\\]{
  min-height: 80vh;
}
.min-h-\\[calc\\(100dvh-15rem\\)\\]{
  min-height: calc(100dvh - 15rem);
}
.min-h-full{
  min-height: 100%;
}
.min-h-screen{
  min-height: 100vh;
}
.w-1\\.5{
  width: 0.375rem;
}
.w-1\\/3{
  width: 33.333333%;
}
.w-10{
  width: 2.5rem;
}
.w-11{
  width: 2.75rem;
}
.w-12{
  width: 3rem;
}
.w-14{
  width: 3.5rem;
}
.w-16{
  width: 4rem;
}
.w-2{
  width: 0.5rem;
}
.w-2\\.5{
  width: 0.625rem;
}
.w-20{
  width: 5rem;
}
.w-24{
  width: 6rem;
}
.w-3{
  width: 0.75rem;
}
.w-3\\.5{
  width: 0.875rem;
}
.w-32{
  width: 8rem;
}
.w-36{
  width: 9rem;
}
.w-4{
  width: 1rem;
}
.w-40{
  width: 10rem;
}
.w-48{
  width: 12rem;
}
.w-5{
  width: 1.25rem;
}
.w-52{
  width: 13rem;
}
.w-56{
  width: 14rem;
}
.w-6{
  width: 1.5rem;
}
.w-60{
  width: 15rem;
}
.w-64{
  width: 16rem;
}
.w-7{
  width: 1.75rem;
}
.w-72{
  width: 18rem;
}
.w-8{
  width: 2rem;
}
.w-80{
  width: 20rem;
}
.w-9{
  width: 2.25rem;
}
.w-96{
  width: 24rem;
}
.w-\\[1001px\\]{
  width: 1001px;
}
.w-\\[124px\\]{
  width: 124px;
}
.w-\\[130px\\]{
  width: 130px;
}
.w-\\[150px\\]{
  width: 150px;
}
.w-\\[1585px\\]{
  width: 1585px;
}
.w-\\[207px\\]{
  width: 207px;
}
.w-\\[214px\\]{
  width: 214px;
}
.w-\\[22px\\]{
  width: 22px;
}
.w-\\[300px\\]{
  width: 300px;
}
.w-\\[309px\\]{
  width: 309px;
}
.w-\\[340px\\]{
  width: 340px;
}
.w-\\[42px\\]{
  width: 42px;
}
.w-\\[52px\\]{
  width: 52px;
}
.w-\\[600px\\]{
  width: 600px;
}
.w-\\[70vw\\]{
  width: 70vw;
}
.w-\\[75vw\\]{
  width: 75vw;
}
.w-\\[88px\\]{
  width: 88px;
}
.w-\\[90\\%\\]{
  width: 90%;
}
.w-\\[92\\%\\]{
  width: 92%;
}
.w-\\[969px\\]{
  width: 969px;
}
.w-\\[971px\\]{
  width: 971px;
}
.w-auto{
  width: auto;
}
.w-fit{
  width: fit-content;
}
.w-full{
  width: 100%;
}
.w-screen{
  width: 100vw;
}
.min-w-0{
  min-width: 0px;
}
.min-w-52{
  min-width: 13rem;
}
.min-w-\\[1\\.5rem\\]{
  min-width: 1.5rem;
}
.min-w-\\[1160px\\]{
  min-width: 1160px;
}
.min-w-\\[12rem\\]{
  min-width: 12rem;
}
.min-w-\\[160px\\]{
  min-width: 160px;
}
.min-w-\\[170px\\]{
  min-width: 170px;
}
.min-w-\\[200px\\]{
  min-width: 200px;
}
.min-w-\\[280px\\]{
  min-width: 280px;
}
.min-w-\\[520px\\]{
  min-width: 520px;
}
.min-w-\\[720px\\]{
  min-width: 720px;
}
.min-w-\\[72px\\]{
  min-width: 72px;
}
.min-w-\\[760px\\]{
  min-width: 760px;
}
.min-w-\\[900px\\]{
  min-width: 900px;
}
.min-w-max{
  min-width: max-content;
}
.\\!max-w-\\[92rem\\]{
  max-width: 92rem !important;
}
.max-w-2xl{
  max-width: 42rem;
}
.max-w-3xl{
  max-width: 48rem;
}
.max-w-4xl{
  max-width: 56rem;
}
.max-w-5xl{
  max-width: 64rem;
}
.max-w-6xl{
  max-width: 72rem;
}
.max-w-7xl{
  max-width: 80rem;
}
.max-w-\\[1320px\\]{
  max-width: 1320px;
}
.max-w-\\[1360px\\]{
  max-width: 1360px;
}
.max-w-\\[1466px\\]{
  max-width: 1466px;
}
.max-w-\\[200px\\]{
  max-width: 200px;
}
.max-w-\\[220px\\]{
  max-width: 220px;
}
.max-w-\\[260px\\]{
  max-width: 260px;
}
.max-w-\\[4\\.5rem\\]{
  max-width: 4.5rem;
}
.max-w-\\[400px\\]{
  max-width: 400px;
}
.max-w-\\[500px\\]{
  max-width: 500px;
}
.max-w-\\[520px\\]{
  max-width: 520px;
}
.max-w-\\[60\\%\\]{
  max-width: 60%;
}
.max-w-\\[640px\\]{
  max-width: 640px;
}
.max-w-\\[75\\%\\]{
  max-width: 75%;
}
.max-w-\\[78\\%\\]{
  max-width: 78%;
}
.max-w-\\[80\\%\\]{
  max-width: 80%;
}
.max-w-\\[840px\\]{
  max-width: 840px;
}
.max-w-\\[85\\%\\]{
  max-width: 85%;
}
.max-w-\\[90\\%\\]{
  max-width: 90%;
}
.max-w-\\[90vw\\]{
  max-width: 90vw;
}
.max-w-\\[96px\\]{
  max-width: 96px;
}
.max-w-\\[calc\\(100vw-2rem\\)\\]{
  max-width: calc(100vw - 2rem);
}
.max-w-full{
  max-width: 100%;
}
.max-w-lg{
  max-width: 32rem;
}
.max-w-md{
  max-width: 28rem;
}
.max-w-none{
  max-width: none;
}
.max-w-rail{
  max-width: 1832px;
}
.max-w-sm{
  max-width: 24rem;
}
.max-w-xl{
  max-width: 36rem;
}
.max-w-xs{
  max-width: 20rem;
}
.flex-1{
  flex: 1 1;
}
.flex-shrink-0{
  flex-shrink: 0;
}
.shrink-0{
  flex-shrink: 0;
}
.basis-full{
  flex-basis: 100%;
}
.border-collapse{
  border-collapse: collapse;
}
.-translate-x-1\\/2{
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2{
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0{
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-1{
  --tw-translate-x: 0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-4{
  --tw-translate-x: 1rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-5{
  --tw-translate-x: 1.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-\\[1px\\]{
  --tw-translate-x: 1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-full{
  --tw-translate-x: 100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180{
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45{
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-90{
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform{
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes bounce{

  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}
.animate-bounce{
  animation: bounce 1s infinite;
}
@keyframes pulse{

  50%{
    opacity: .5;
  }
}
.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin{

  to{
    transform: rotate(360deg);
  }
}
.animate-spin{
  animation: spin 1s linear infinite;
}
.cursor-grab{
  cursor: grab;
}
.cursor-move{
  cursor: move;
}
.cursor-not-allowed{
  cursor: not-allowed;
}
.cursor-pointer{
  cursor: pointer;
}
.cursor-text{
  cursor: text;
}
.select-none{
  -webkit-user-select: none;
          user-select: none;
}
.resize-none{
  resize: none;
}
.resize{
  resize: both;
}
.snap-x{
  scroll-snap-type: x var(--tw-scroll-snap-strictness);
}
.snap-mandatory{
  --tw-scroll-snap-strictness: mandatory;
}
.snap-start{
  scroll-snap-align: start;
}
.list-inside{
  list-style-position: inside;
}
.list-decimal{
  list-style-type: decimal;
}
.list-disc{
  list-style-type: disc;
}
.list-none{
  list-style-type: none;
}
.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-10{
  grid-template-columns: repeat(10, minmax(0, 1fr));
}
.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-\\[1fr_140px_100px_64px\\]{
  grid-template-columns: 1fr 140px 100px 64px;
}
.grid-cols-\\[1fr_140px_140px_32px\\]{
  grid-template-columns: 1fr 140px 140px 32px;
}
.grid-cols-\\[1fr_2fr_auto\\]{
  grid-template-columns: 1fr 2fr auto;
}
.grid-cols-\\[46px_1fr_34px\\]{
  grid-template-columns: 46px 1fr 34px;
}
.flex-col{
  flex-direction: column;
}
.flex-wrap{
  flex-wrap: wrap;
}
.content-start{
  align-content: flex-start;
}
.items-start{
  align-items: flex-start;
}
.items-end{
  align-items: flex-end;
}
.items-center{
  align-items: center;
}
.items-stretch{
  align-items: stretch;
}
.justify-start{
  justify-content: flex-start;
}
.justify-end{
  justify-content: flex-end;
}
.justify-center{
  justify-content: center;
}
.justify-between{
  justify-content: space-between;
}
.justify-items-center{
  justify-items: center;
}
.gap-1{
  gap: 0.25rem;
}
.gap-1\\.5{
  gap: 0.375rem;
}
.gap-10{
  gap: 2.5rem;
}
.gap-12{
  gap: 3rem;
}
.gap-2{
  gap: 0.5rem;
}
.gap-2\\.5{
  gap: 0.625rem;
}
.gap-3{
  gap: 0.75rem;
}
.gap-4{
  gap: 1rem;
}
.gap-5{
  gap: 1.25rem;
}
.gap-6{
  gap: 1.5rem;
}
.gap-7{
  gap: 1.75rem;
}
.gap-8{
  gap: 2rem;
}
.gap-\\[10px\\]{
  gap: 10px;
}
.gap-\\[2px\\]{
  gap: 2px;
}
.gap-\\[6px\\]{
  gap: 6px;
}
.gap-x-10{
  column-gap: 2.5rem;
}
.gap-x-3{
  column-gap: 0.75rem;
}
.gap-x-4{
  column-gap: 1rem;
}
.gap-x-6{
  column-gap: 1.5rem;
}
.gap-y-1{
  row-gap: 0.25rem;
}
.gap-y-4{
  row-gap: 1rem;
}
.-space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(-0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(-0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--tw-space-x-reverse));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--tw-space-x-reverse));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-x-reverse: 0;
  margin-right: calc(2rem * var(--tw-space-x-reverse));
  margin-left: calc(2rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-0\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.125rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.125rem * var(--tw-space-y-reverse));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.375rem * var(--tw-space-y-reverse));
}
.space-y-10 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-2\\.5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.625rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.625rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.space-y-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-y-reverse: 0;
  margin-top: calc(2rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(2rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]){
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-agentic-gray-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(var(--agentic-gray-100, 243 244 246) / var(--tw-divide-opacity, 1));
}
.divide-agentic-gray-200 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(var(--agentic-gray-200, 229 231 235) / var(--tw-divide-opacity, 1));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-opacity: 1;
  border-color: rgb(var(--tw-gray-100, 243 244 246) / var(--tw-divide-opacity, 1));
}
.self-start{
  align-self: flex-start;
}
.self-end{
  align-self: flex-end;
}
.overflow-auto{
  overflow: auto;
}
.overflow-hidden{
  overflow: hidden;
}
.overflow-visible{
  overflow: visible;
}
.overflow-x-auto{
  overflow-x: auto;
}
.overflow-y-auto{
  overflow-y: auto;
}
.overflow-x-hidden{
  overflow-x: hidden;
}
.overscroll-x-contain{
  overscroll-behavior-x: contain;
}
.scroll-smooth{
  scroll-behavior: smooth;
}
.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap{
  white-space: nowrap;
}
.whitespace-pre-wrap{
  white-space: pre-wrap;
}
.break-words{
  overflow-wrap: break-word;
}
.break-all{
  word-break: break-all;
}
.rounded{
  border-radius: 0.25rem;
}
.rounded-2xl{
  border-radius: 1rem;
}
.rounded-3xl{
  border-radius: 1.5rem;
}
.rounded-\\[10px\\]{
  border-radius: 10px;
}
.rounded-\\[12px\\]{
  border-radius: 12px;
}
.rounded-\\[18px\\]{
  border-radius: 18px;
}
.rounded-\\[20px\\]{
  border-radius: 20px;
}
.rounded-\\[24px\\]{
  border-radius: 24px;
}
.rounded-\\[30px\\]{
  border-radius: 30px;
}
.rounded-\\[4px\\]{
  border-radius: 4px;
}
.rounded-\\[50px\\]{
  border-radius: 50px;
}
.rounded-\\[6px\\]{
  border-radius: 6px;
}
.rounded-\\[8px\\]{
  border-radius: 8px;
}
.rounded-\\[999px\\]{
  border-radius: 999px;
}
.rounded-card{
  border-radius: 2rem;
}
.rounded-full{
  border-radius: 9999px;
}
.rounded-lg{
  border-radius: 0.5rem;
}
.rounded-md{
  border-radius: 0.375rem;
}
.rounded-nav{
  border-radius: 10px;
}
.rounded-panel{
  border-radius: 1.5rem;
}
.rounded-sm{
  border-radius: 0.125rem;
}
.rounded-xl{
  border-radius: 0.75rem;
}
.rounded-b-2xl{
  border-bottom-right-radius: 1rem;
  border-bottom-left-radius: 1rem;
}
.rounded-b-md{
  border-bottom-right-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}
.rounded-t-2xl{
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
}
.rounded-t-xl{
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.rounded-tl-\\[10px\\]{
  border-top-left-radius: 10px;
}
.border{
  border-width: 1px;
}
.border-0{
  border-width: 0px;
}
.border-2{
  border-width: 2px;
}
.border-4{
  border-width: 4px;
}
.border-\\[2px\\]{
  border-width: 2px;
}
.border-y{
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b{
  border-bottom-width: 1px;
}
.border-b-2{
  border-bottom-width: 2px;
}
.border-b-\\[3px\\]{
  border-bottom-width: 3px;
}
.border-l{
  border-left-width: 1px;
}
.border-l-2{
  border-left-width: 2px;
}
.border-l-4{
  border-left-width: 4px;
}
.border-r{
  border-right-width: 1px;
}
.border-t{
  border-top-width: 1px;
}
.border-dashed{
  border-style: dashed;
}
.border-\\[\\#13b546\\]{
  --tw-border-opacity: 1;
  border-color: rgb(19 181 70 / var(--tw-border-opacity, 1));
}
.border-\\[\\#75f5ec\\]{
  --tw-border-opacity: 1;
  border-color: rgb(117 245 236 / var(--tw-border-opacity, 1));
}
.border-\\[\\#caebd3\\]{
  --tw-border-opacity: 1;
  border-color: rgb(202 235 211 / var(--tw-border-opacity, 1));
}
.border-agentic-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(var(--agentic-gray-100, 243 244 246) / var(--tw-border-opacity, 1));
}
.border-agentic-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--agentic-gray-200, 229 231 235) / var(--tw-border-opacity, 1));
}
.border-agentic-gray-200\\/60{
  border-color: rgb(var(--agentic-gray-200, 229 231 235) / 0.6);
}
.border-agentic-gray-200\\/70{
  border-color: rgb(var(--agentic-gray-200, 229 231 235) / 0.7);
}
.border-agentic-gray-200\\/80{
  border-color: rgb(var(--agentic-gray-200, 229 231 235) / 0.8);
}
.border-agentic-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--agentic-gray-300, 209 213 219) / var(--tw-border-opacity, 1));
}
.border-agentic-primary-blue{
  --tw-border-opacity: 1;
  border-color: rgb(var(--agentic-primary-blue, 30 58 138) / var(--tw-border-opacity, 1));
}
.border-agentic-primary-blue\\/30{
  border-color: rgb(var(--agentic-primary-blue, 30 58 138) / 0.3);
}
.border-agentic-primary-blue\\/35{
  border-color: rgb(var(--agentic-primary-blue, 30 58 138) / 0.35);
}
.border-agentic-text-secondary{
  --tw-border-opacity: 1;
  border-color: rgb(var(--agentic-text-secondary, 107 114 128) / var(--tw-border-opacity, 1));
}
.border-amber-200{
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-amber-400{
  --tw-border-opacity: 1;
  border-color: rgb(251 191 36 / var(--tw-border-opacity, 1));
}
.border-blue-100{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-blue-100, 219 234 254) / var(--tw-border-opacity, 1));
}
.border-blue-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-blue-200, 191 219 254) / var(--tw-border-opacity, 1));
}
.border-blue-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-blue-300, 147 197 253) / var(--tw-border-opacity, 1));
}
.border-blue-400{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-blue-400, 96 165 250) / var(--tw-border-opacity, 1));
}
.border-blue-600{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-blue-600, 37 99 235) / var(--tw-border-opacity, 1));
}
.border-c-0066cc{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-0066cc, 0 102 204) / var(--tw-border-opacity, 1));
}
.border-c-1f1f1f{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-1f1f1f, 31 31 31) / var(--tw-border-opacity, 1));
}
.border-c-3683c6{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-3683c6, 54 131 198) / var(--tw-border-opacity, 1));
}
.border-c-808080\\/30{
  border-color: rgb(var(--c-808080, 128 128 128) / 0.3);
}
.border-c-9cb7ec{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-9cb7ec, 156 183 236) / var(--tw-border-opacity, 1));
}
.border-c-afc4f8{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-afc4f8, 175 196 248) / var(--tw-border-opacity, 1));
}
.border-c-c3c3c3{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-c3c3c3, 195 195 195) / var(--tw-border-opacity, 1));
}
.border-c-c3ccd8{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-c3ccd8, 195 204 216) / var(--tw-border-opacity, 1));
}
.border-c-c9d3ee{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-c9d3ee, 201 211 238) / var(--tw-border-opacity, 1));
}
.border-c-cfd8f6{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-cfd8f6, 207 216 246) / var(--tw-border-opacity, 1));
}
.border-c-cfe1ff{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-cfe1ff, 207 225 255) / var(--tw-border-opacity, 1));
}
.border-c-d1d7e2{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-d1d7e2, 209 215 226) / var(--tw-border-opacity, 1));
}
.border-c-d5ddfb{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-d5ddfb, 213 221 251) / var(--tw-border-opacity, 1));
}
.border-c-d7dde7{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-d7dde7, 215 221 231) / var(--tw-border-opacity, 1));
}
.border-c-d8dee8{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-d8dee8, 216 222 232) / var(--tw-border-opacity, 1));
}
.border-c-dfe5f8{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-dfe5f8, 223 229 248) / var(--tw-border-opacity, 1));
}
.border-c-e2d9f8{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-e2d9f8, 226 217 248) / var(--tw-border-opacity, 1));
}
.border-c-e3e7f3{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-e3e7f3, 227 231 243) / var(--tw-border-opacity, 1));
}
.border-c-e3e7f7{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-e3e7f7, 227 231 247) / var(--tw-border-opacity, 1));
}
.border-c-eef1fb{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-eef1fb, 238 241 251) / var(--tw-border-opacity, 1));
}
.border-current{
  border-color: currentColor;
}
.border-emerald-200{
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-gray-100{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-gray-100, 243 244 246) / var(--tw-border-opacity, 1));
}
.border-gray-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-gray-200, 229 231 235) / var(--tw-border-opacity, 1));
}
.border-gray-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-gray-300, 209 213 219) / var(--tw-border-opacity, 1));
}
.border-green-200{
  --tw-border-opacity: 1;
  border-color: rgb(187 247 208 / var(--tw-border-opacity, 1));
}
.border-green-300{
  --tw-border-opacity: 1;
  border-color: rgb(134 239 172 / var(--tw-border-opacity, 1));
}
.border-green-400{
  --tw-border-opacity: 1;
  border-color: rgb(74 222 128 / var(--tw-border-opacity, 1));
}
.border-kv-agentic-blue{
  --tw-border-opacity: 1;
  border-color: rgb(var(--kv-agentic-blue, 54 131 198) / var(--tw-border-opacity, 1));
}
.border-orange-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 215 170 / var(--tw-border-opacity, 1));
}
.border-purple-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-purple-200, 233 213 255) / var(--tw-border-opacity, 1));
}
.border-red-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-400{
  --tw-border-opacity: 1;
  border-color: rgb(248 113 113 / var(--tw-border-opacity, 1));
}
.border-rose-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.border-sky-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-sky-200, 186 230 253) / var(--tw-border-opacity, 1));
}
.border-slate-100{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-slate-100, 241 245 249) / var(--tw-border-opacity, 1));
}
.border-slate-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-slate-200, 226 232 240) / var(--tw-border-opacity, 1));
}
.border-slate-300{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-slate-300, 203 213 225) / var(--tw-border-opacity, 1));
}
.border-transparent{
  border-color: transparent;
}
.border-violet-200{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-violet-200, 221 214 254) / var(--tw-border-opacity, 1));
}
.border-violet-400{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-violet-400, 167 139 250) / var(--tw-border-opacity, 1));
}
.border-white{
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.border-white\\/20{
  border-color: rgb(255 255 255 / 0.2);
}
.border-white\\/25{
  border-color: rgb(255 255 255 / 0.25);
}
.border-white\\/30{
  border-color: rgb(255 255 255 / 0.3);
}
.border-white\\/40{
  border-color: rgb(255 255 255 / 0.4);
}
.border-white\\/70{
  border-color: rgb(255 255 255 / 0.7);
}
.border-yellow-200{
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
.border-yellow-300{
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity, 1));
}
.border-l-transparent{
  border-left-color: transparent;
}
.border-t-transparent{
  border-top-color: transparent;
}
.bg-\\[\\#13b546\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(19 181 70 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1877F2\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(24 119 242 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1877F2\\]\\/\\[0\\.06\\]{
  background-color: rgb(24 119 242 / 0.06);
}
.bg-\\[\\#2f9444\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(47 148 68 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d92e2e\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(217 46 46 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ed6567\\]{
  --tw-bg-opacity: 1;
  background-color: rgb(237 101 103 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#f3c6cf\\]\\/25{
  background-color: rgb(243 198 207 / 0.25);
}
.bg-\\[rgb\\(var\\(--c-e7dff4\\2c 231_223_244\\)\\/0\\.40\\)\\]{
  background-color: rgb(var(--c-e7dff4,231 223 244)/0.40);
}
.bg-agentic-accent-green{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-accent-green, 16 185 129) / var(--tw-bg-opacity, 1));
}
.bg-agentic-accent-green\\/10{
  background-color: rgb(var(--agentic-accent-green, 16 185 129) / 0.1);
}
.bg-agentic-accent-purple\\/10{
  background-color: rgb(var(--agentic-accent-purple, 139 92 246) / 0.1);
}
.bg-agentic-accent-red{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-accent-red, 239 68 68) / var(--tw-bg-opacity, 1));
}
.bg-agentic-accent-red\\/10{
  background-color: rgb(var(--agentic-accent-red, 239 68 68) / 0.1);
}
.bg-agentic-accent-yellow{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-accent-yellow, 245 158 11) / var(--tw-bg-opacity, 1));
}
.bg-agentic-accent-yellow\\/10{
  background-color: rgb(var(--agentic-accent-yellow, 245 158 11) / 0.1);
}
.bg-agentic-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-gray-100, 243 244 246) / var(--tw-bg-opacity, 1));
}
.bg-agentic-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-gray-200, 229 231 235) / var(--tw-bg-opacity, 1));
}
.bg-agentic-gray-200\\/80{
  background-color: rgb(var(--agentic-gray-200, 229 231 235) / 0.8);
}
.bg-agentic-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-gray-300, 209 213 219) / var(--tw-bg-opacity, 1));
}
.bg-agentic-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-gray-50, 249 250 251) / var(--tw-bg-opacity, 1));
}
.bg-agentic-gray-50\\/50{
  background-color: rgb(var(--agentic-gray-50, 249 250 251) / 0.5);
}
.bg-agentic-gray-50\\/90{
  background-color: rgb(var(--agentic-gray-50, 249 250 251) / 0.9);
}
.bg-agentic-primary-blue{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-primary-blue, 30 58 138) / var(--tw-bg-opacity, 1));
}
.bg-agentic-primary-blue\\/10{
  background-color: rgb(var(--agentic-primary-blue, 30 58 138) / 0.1);
}
.bg-agentic-primary-blue\\/5{
  background-color: rgb(var(--agentic-primary-blue, 30 58 138) / 0.05);
}
.bg-agentic-white{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-white, 255 255 255) / var(--tw-bg-opacity, 1));
}
.bg-agentic-white-off{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-white-off, 248 250 252) / var(--tw-bg-opacity, 1));
}
.bg-amber-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-500{
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-600{
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.bg-black{
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/0{
  background-color: rgb(0 0 0 / 0);
}
.bg-black\\/30{
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}
.bg-black\\/45{
  background-color: rgb(0 0 0 / 0.45);
}
.bg-black\\/50{
  background-color: rgb(0 0 0 / 0.5);
}
.bg-black\\/70{
  background-color: rgb(0 0 0 / 0.7);
}
.bg-blue-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-blue-100, 219 234 254) / var(--tw-bg-opacity, 1));
}
.bg-blue-200{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-blue-200, 191 219 254) / var(--tw-bg-opacity, 1));
}
.bg-blue-300{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-blue-300, 147 197 253) / var(--tw-bg-opacity, 1));
}
.bg-blue-400{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-blue-400, 96 165 250) / var(--tw-bg-opacity, 1));
}
.bg-blue-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-blue-50, 239 246 255) / var(--tw-bg-opacity, 1));
}
.bg-blue-50\\/40{
  background-color: rgb(var(--tw-blue-50, 239 246 255) / 0.4);
}
.bg-blue-50\\/50{
  background-color: rgb(var(--tw-blue-50, 239 246 255) / 0.5);
}
.bg-blue-50\\/60{
  background-color: rgb(var(--tw-blue-50, 239 246 255) / 0.6);
}
.bg-blue-500{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-blue-500, 59 130 246) / var(--tw-bg-opacity, 1));
}
.bg-blue-600{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-blue-600, 37 99 235) / var(--tw-bg-opacity, 1));
}
.bg-blue-700{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-blue-700, 29 78 216) / var(--tw-bg-opacity, 1));
}
.bg-c-0066cc{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-0066cc, 0 102 204) / var(--tw-bg-opacity, 1));
}
.bg-c-07103b{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-07103b, 7 16 59) / var(--tw-bg-opacity, 1));
}
.bg-c-1f1f1f{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-1f1f1f, 31 31 31) / var(--tw-bg-opacity, 1));
}
.bg-c-1f204d\\/40{
  background-color: rgb(var(--c-1f204d, 31 32 77) / 0.4);
}
.bg-c-59c6f9\\/25{
  background-color: rgb(var(--c-59c6f9, 89 198 249) / 0.25);
}
.bg-c-5c4fcf{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-5c4fcf, 92 79 207) / var(--tw-bg-opacity, 1));
}
.bg-c-6071ec{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-6071ec, 96 113 236) / var(--tw-bg-opacity, 1));
}
.bg-c-7f54dc{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-7f54dc, 127 84 220) / var(--tw-bg-opacity, 1));
}
.bg-c-9e8bff\\/35{
  background-color: rgb(var(--c-9e8bff, 158 139 255) / 0.35);
}
.bg-c-a9c7e6\\/25{
  background-color: rgb(var(--c-a9c7e6, 169 199 230) / 0.25);
}
.bg-c-c6ccd7{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-c6ccd7, 198 204 215) / var(--tw-bg-opacity, 1));
}
.bg-c-c9b8ec\\/25{
  background-color: rgb(var(--c-c9b8ec, 201 184 236) / 0.25);
}
.bg-c-d7cff6{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-d7cff6, 215 207 246) / var(--tw-bg-opacity, 1));
}
.bg-c-e6effb{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-e6effb, 230 239 251) / var(--tw-bg-opacity, 1));
}
.bg-c-e7dff4\\/40{
  background-color: rgb(var(--c-e7dff4, 231 223 244) / 0.4);
}
.bg-c-e8eef8{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-e8eef8, 232 238 248) / var(--tw-bg-opacity, 1));
}
.bg-c-e8f5ec{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-e8f5ec, 232 245 236) / var(--tw-bg-opacity, 1));
}
.bg-c-ebedf1{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-ebedf1, 235 237 241) / var(--tw-bg-opacity, 1));
}
.bg-c-ede9ff{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-ede9ff, 237 233 255) / var(--tw-bg-opacity, 1));
}
.bg-c-edf3fb{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-edf3fb, 237 243 251) / var(--tw-bg-opacity, 1));
}
.bg-c-edf9ec{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-edf9ec, 237 249 236) / var(--tw-bg-opacity, 1));
}
.bg-c-eee8fb{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-eee8fb, 238 232 251) / var(--tw-bg-opacity, 1));
}
.bg-c-eeebf7{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-eeebf7, 238 235 247) / var(--tw-bg-opacity, 1));
}
.bg-c-eef2fd{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-eef2fd, 238 242 253) / var(--tw-bg-opacity, 1));
}
.bg-c-f3f4fa{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-f3f4fa, 243 244 250) / var(--tw-bg-opacity, 1));
}
.bg-c-f3f5fb{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-f3f5fb, 243 245 251) / var(--tw-bg-opacity, 1));
}
.bg-c-f5f7fa{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-f5f7fa, 245 247 250) / var(--tw-bg-opacity, 1));
}
.bg-c-f6f8fc{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-f6f8fc, 246 248 252) / var(--tw-bg-opacity, 1));
}
.bg-c-f6fff8{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-f6fff8, 246 255 248) / var(--tw-bg-opacity, 1));
}
.bg-c-f7f9fc{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-f7f9fc, 247 249 252) / var(--tw-bg-opacity, 1));
}
.bg-c-f7fbff{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-f7fbff, 247 251 255) / var(--tw-bg-opacity, 1));
}
.bg-c-f8f8fc{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-f8f8fc, 248 248 252) / var(--tw-bg-opacity, 1));
}
.bg-c-faf8ff{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-faf8ff, 250 248 255) / var(--tw-bg-opacity, 1));
}
.bg-c-fbfcfe{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-fbfcfe, 251 252 254) / var(--tw-bg-opacity, 1));
}
.bg-emerald-100{
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-400{
  --tw-bg-opacity: 1;
  background-color: rgb(52 211 153 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500{
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-gray-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-gray-100, 243 244 246) / var(--tw-bg-opacity, 1));
}
.bg-gray-200{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-gray-200, 229 231 235) / var(--tw-bg-opacity, 1));
}
.bg-gray-300{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-gray-300, 209 213 219) / var(--tw-bg-opacity, 1));
}
.bg-gray-400{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-gray-400, 156 163 175) / var(--tw-bg-opacity, 1));
}
.bg-gray-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-gray-50, 249 250 251) / var(--tw-bg-opacity, 1));
}
.bg-gray-50\\/50{
  background-color: rgb(var(--tw-gray-50, 249 250 251) / 0.5);
}
.bg-gray-50\\/60{
  background-color: rgb(var(--tw-gray-50, 249 250 251) / 0.6);
}
.bg-gray-900{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-gray-900, 17 24 39) / var(--tw-bg-opacity, 1));
}
.bg-green-100{
  --tw-bg-opacity: 1;
  background-color: rgb(220 252 231 / var(--tw-bg-opacity, 1));
}
.bg-green-200{
  --tw-bg-opacity: 1;
  background-color: rgb(187 247 208 / var(--tw-bg-opacity, 1));
}
.bg-green-300{
  --tw-bg-opacity: 1;
  background-color: rgb(134 239 172 / var(--tw-bg-opacity, 1));
}
.bg-green-400{
  --tw-bg-opacity: 1;
  background-color: rgb(74 222 128 / var(--tw-bg-opacity, 1));
}
.bg-green-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}
.bg-green-500{
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity, 1));
}
.bg-green-600{
  --tw-bg-opacity: 1;
  background-color: rgb(22 163 74 / var(--tw-bg-opacity, 1));
}
.bg-indigo-500{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-indigo-500, 99 102 241) / var(--tw-bg-opacity, 1));
}
.bg-kv-agentic-blue{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--kv-agentic-blue, 54 131 198) / var(--tw-bg-opacity, 1));
}
.bg-kv-agentic-blue\\/10{
  background-color: rgb(var(--kv-agentic-blue, 54 131 198) / 0.1);
}
.bg-kv-agentic-surface-lilac{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--kv-agentic-surface-lilac, 243 238 251) / var(--tw-bg-opacity, 1));
}
.bg-orange-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-pink-50{
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity, 1));
}
.bg-purple-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-purple-50, 250 245 255) / var(--tw-bg-opacity, 1));
}
.bg-purple-600{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-purple-600, 147 51 234) / var(--tw-bg-opacity, 1));
}
.bg-red-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.bg-red-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500{
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-red-600{
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity, 1));
}
.bg-rose-100{
  --tw-bg-opacity: 1;
  background-color: rgb(255 228 230 / var(--tw-bg-opacity, 1));
}
.bg-rose-50{
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-500{
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.bg-sky-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-sky-100, 224 242 254) / var(--tw-bg-opacity, 1));
}
.bg-sky-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-sky-50, 240 249 255) / var(--tw-bg-opacity, 1));
}
.bg-sky-500{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-sky-500, 14 165 233) / var(--tw-bg-opacity, 1));
}
.bg-slate-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-slate-100, 241 245 249) / var(--tw-bg-opacity, 1));
}
.bg-slate-400{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-slate-400, 148 163 184) / var(--tw-bg-opacity, 1));
}
.bg-slate-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-slate-50, 248 250 252) / var(--tw-bg-opacity, 1));
}
.bg-teal-50{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 250 / var(--tw-bg-opacity, 1));
}
.bg-teal-500{
  --tw-bg-opacity: 1;
  background-color: rgb(20 184 166 / var(--tw-bg-opacity, 1));
}
.bg-transparent{
  background-color: transparent;
}
.bg-violet-100{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-violet-100, 237 233 254) / var(--tw-bg-opacity, 1));
}
.bg-violet-50{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-violet-50, 245 243 255) / var(--tw-bg-opacity, 1));
}
.bg-violet-50\\/60{
  background-color: rgb(var(--tw-violet-50, 245 243 255) / 0.6);
}
.bg-violet-500{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-violet-500, 139 92 246) / var(--tw-bg-opacity, 1));
}
.bg-violet-600{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-violet-600, 124 58 237) / var(--tw-bg-opacity, 1));
}
.bg-white{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10{
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/20{
  background-color: rgb(255 255 255 / 0.2);
}
.bg-white\\/30{
  background-color: rgb(255 255 255 / 0.3);
}
.bg-white\\/40{
  background-color: rgb(255 255 255 / 0.4);
}
.bg-white\\/60{
  background-color: rgb(255 255 255 / 0.6);
}
.bg-white\\/70{
  background-color: rgb(255 255 255 / 0.7);
}
.bg-white\\/80{
  background-color: rgb(255 255 255 / 0.8);
}
.bg-white\\/90{
  background-color: rgb(255 255 255 / 0.9);
}
.bg-white\\/95{
  background-color: rgb(255 255 255 / 0.95);
}
.bg-yellow-100{
  --tw-bg-opacity: 1;
  background-color: rgb(254 249 195 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50{
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-yellow-500{
  --tw-bg-opacity: 1;
  background-color: rgb(234 179 8 / var(--tw-bg-opacity, 1));
}
.\\!bg-\\[linear-gradient\\(90deg\\2c \\#FFFFFF_0\\%\\2c rgba\\(237\\2c 101\\2c 113\\2c 0\\.10\\)_100\\%\\)\\]{
  background-image: linear-gradient(90deg,#FFFFFF 0%,rgba(237,101,113,0.10) 100%) !important;
}
.bg-\\[linear-gradient\\(135deg\\2c rgb\\(var\\(--c-fceff1\\2c 252_239_241\\)\\)_0\\%\\2c \\#FFFFFF_42\\%\\2c rgb\\(var\\(--c-f3f1fb\\2c 243_241_251\\)\\)_100\\%\\)\\]{
  background-image: linear-gradient(135deg,rgb(var(--c-fceff1,252 239 241)) 0%,#FFFFFF 42%,rgb(var(--c-f3f1fb,243 241 251)) 100%);
}
.bg-\\[linear-gradient\\(180deg\\2c \\#FFFFFF_0\\%\\2c \\#4CC4D012_100\\%\\)\\]{
  background-image: linear-gradient(180deg,#FFFFFF 0%,#4CC4D012 100%);
}
.bg-\\[linear-gradient\\(180deg\\2c rgb\\(var\\(--c-f5f7fa\\2c 245_247_250\\)\\)_0\\%\\2c rgb\\(var\\(--c-f5f7fa\\2c 245_247_250\\)\\)_72\\%\\2c rgb\\(var\\(--c-f3eefb\\2c 243_238_251\\)\\)_100\\%\\)\\]{
  background-image: linear-gradient(180deg,rgb(var(--c-f5f7fa,245 247 250)) 0%,rgb(var(--c-f5f7fa,245 247 250)) 72%,rgb(var(--c-f3eefb,243 238 251)) 100%);
}
.bg-\\[linear-gradient\\(90deg\\2c rgb\\(var\\(--c-1f1f1f\\2c 31_31_31\\)\\/1\\)_0\\%\\2c rgb\\(var\\(--c-1f1f1f\\2c 31_31_31\\)\\/1\\)_56\\%\\2c rgb\\(var\\(--c-171e2c\\2c 23_30_44\\)\\/0\\.96\\)_74\\%\\2c rgb\\(var\\(--c-0c3549\\2c 12_53_73\\)\\/0\\.9\\)_100\\%\\)\\]{
  background-image: linear-gradient(90deg,rgb(var(--c-1f1f1f,31 31 31)/1) 0%,rgb(var(--c-1f1f1f,31 31 31)/1) 56%,rgb(var(--c-171e2c,23 30 44)/0.96) 74%,rgb(var(--c-0c3549,12 53 73)/0.9) 100%);
}
.bg-\\[linear-gradient\\(90deg\\2c rgb\\(var\\(--c-f5f7fa\\2c 245_247_250\\)\\/0\\)_58\\%\\2c rgb\\(var\\(--c-edf5f7\\2c 237_245_247\\)\\/0\\.95\\)_100\\%\\)\\]{
  background-image: linear-gradient(90deg,rgb(var(--c-f5f7fa,245 247 250)/0) 58%,rgb(var(--c-edf5f7,237 245 247)/0.95) 100%);
}
.bg-\\[linear-gradient\\(90deg\\2c rgba\\(255\\2c 255\\2c 255\\2c 0\\.92\\)_0\\%\\2c rgba\\(237\\2c 101\\2c 113\\2c 0\\.10\\)_100\\%\\)\\]{
  background-image: linear-gradient(90deg,rgba(255,255,255,0.92) 0%,rgba(237,101,113,0.10) 100%);
}
.bg-\\[radial-gradient\\(circle\\2c rgb\\(var\\(--c-bedff1\\2c 190_223_241\\)\\/0\\.23\\)_0\\%\\2c rgb\\(var\\(--c-bedff1\\2c 190_223_241\\)\\/0\\)_76\\%\\)\\]{
  background-image: radial-gradient(circle,rgb(var(--c-bedff1,190 223 241)/0.23) 0%,rgb(var(--c-bedff1,190 223 241)/0) 76%);
}
.bg-\\[radial-gradient\\(circle\\2c rgb\\(var\\(--c-d5cdeb\\2c 213_205_235\\)\\/0\\.55\\)_0\\%\\2c rgb\\(var\\(--c-d5cdeb\\2c 213_205_235\\)\\/0\\)_72\\%\\)\\]{
  background-image: radial-gradient(circle,rgb(var(--c-d5cdeb,213 205 235)/0.55) 0%,rgb(var(--c-d5cdeb,213 205 235)/0) 72%);
}
.bg-\\[radial-gradient\\(circle\\2c rgb\\(var\\(--c-d6e3e8\\2c 214_227_232\\)\\/0\\.75\\)_0\\%\\2c rgb\\(var\\(--c-d6e3e8\\2c 214_227_232\\)\\/0\\)_72\\%\\)\\]{
  background-image: radial-gradient(circle,rgb(var(--c-d6e3e8,214 227 232)/0.75) 0%,rgb(var(--c-d6e3e8,214 227 232)/0) 72%);
}
.bg-\\[radial-gradient\\(circle\\2c rgb\\(var\\(--c-efdde6\\2c 239_221_230\\)\\/0\\.55\\)_0\\%\\2c rgb\\(var\\(--c-efdde6\\2c 239_221_230\\)\\/0\\)_74\\%\\)\\]{
  background-image: radial-gradient(circle,rgb(var(--c-efdde6,239 221 230)/0.55) 0%,rgb(var(--c-efdde6,239 221 230)/0) 74%);
}
.bg-\\[radial-gradient\\(circle\\2c rgb\\(var\\(--c-f2e2eb\\2c 242_226_235\\)\\/0\\.42\\)_0\\%\\2c rgb\\(var\\(--c-f2e2eb\\2c 242_226_235\\)\\/0\\)_72\\%\\)\\]{
  background-image: radial-gradient(circle,rgb(var(--c-f2e2eb,242 226 235)/0.42) 0%,rgb(var(--c-f2e2eb,242 226 235)/0) 72%);
}
.bg-\\[radial-gradient\\(circle\\2c rgba\\(17\\2c 172\\2c 182\\2c 0\\.34\\)_0\\%\\2c rgba\\(17\\2c 172\\2c 182\\2c 0\\)_66\\%\\)\\]{
  background-image: radial-gradient(circle,rgba(17,172,182,0.34) 0%,rgba(17,172,182,0) 66%);
}
.bg-\\[radial-gradient\\(circle_at_20\\%_20\\%\\2c rgb\\(var\\(--c-584ab4\\2c 88_74_180\\)\\/0\\.38\\)\\2c transparent_35\\%\\)\\2c radial-gradient\\(circle_at_75\\%_25\\%\\2c rgb\\(var\\(--c-1b5b99\\2c 27_91_153\\)\\/0\\.35\\)\\2c transparent_40\\%\\)\\2c linear-gradient\\(105deg\\2c rgb\\(var\\(--c-151722\\2c 21_23_34\\)\\)\\2c rgb\\(var\\(--c-10151e\\2c 16_21_30\\)\\)_55\\%\\2c rgb\\(var\\(--c-101a26\\2c 16_26_38\\)\\)\\)\\]{
  background-image: radial-gradient(circle at 20% 20%,rgb(var(--c-584ab4,88 74 180)/0.38),transparent 35%),radial-gradient(circle at 75% 25%,rgb(var(--c-1b5b99,27 91 153)/0.35),transparent 40%),linear-gradient(105deg,rgb(var(--c-151722,21 23 34)),rgb(var(--c-10151e,16 21 30)) 55%,rgb(var(--c-101a26,16 26 38)));
}
.bg-\\[radial-gradient\\(circle_at_20\\%_20\\%\\2c rgba\\(77\\2c 207\\2c 190\\2c 0\\.75\\)\\2c transparent_46\\%\\)\\2c linear-gradient\\(150deg\\2c rgb\\(var\\(--c-0f7f9d\\2c 15_127_157\\)\\)\\2c rgb\\(var\\(--c-0e6787\\2c 14_103_135\\)\\)_45\\%\\2c rgb\\(var\\(--c-17408a\\2c 23_64_138\\)\\)\\)\\]{
  background-image: radial-gradient(circle at 20% 20%,rgba(77,207,190,0.75),transparent 46%),linear-gradient(150deg,rgb(var(--c-0f7f9d,15 127 157)),rgb(var(--c-0e6787,14 103 135)) 45%,rgb(var(--c-17408a,23 64 138)));
}
.bg-\\[radial-gradient\\(circle_at_28\\%_28\\%\\2c rgb\\(var\\(--c-f9f4ff\\2c 249_244_255\\)\\)_0\\%\\2c rgb\\(var\\(--c-dcbef9\\2c 220_190_249\\)\\)_55\\%\\2c rgb\\(var\\(--c-8bb3ff\\2c 139_179_255\\)\\)_100\\%\\)\\]{
  background-image: radial-gradient(circle at 28% 28%,rgb(var(--c-f9f4ff,249 244 255)) 0%,rgb(var(--c-dcbef9,220 190 249)) 55%,rgb(var(--c-8bb3ff,139 179 255)) 100%);
}
.bg-\\[radial-gradient\\(circle_at_50\\%_20\\%\\2c rgb\\(var\\(--c-14218a\\2c 20_33_138\\)\\)\\2c rgb\\(var\\(--c-05062b\\2c 5_6_43\\)\\)_55\\%\\2c rgb\\(var\\(--c-040624\\2c 4_6_36\\)\\)_100\\%\\)\\]{
  background-image: radial-gradient(circle at 50% 20%,rgb(var(--c-14218a,20 33 138)),rgb(var(--c-05062b,5 6 43)) 55%,rgb(var(--c-040624,4 6 36)) 100%);
}
.bg-\\[radial-gradient\\(circle_at_50\\%_45\\%\\2c rgba\\(76\\2c 236\\2c 218\\2c 0\\.18\\)\\2c rgb\\(var\\(--c-040624\\2c 4_6_36\\)\\/0\\.2\\)_60\\%\\)\\]{
  background-image: radial-gradient(circle at 50% 45%,rgba(76,236,218,0.18),rgb(var(--c-040624,4 6 36)/0.2) 60%);
}
.bg-\\[radial-gradient\\(circle_at_78\\%_64\\%\\2c rgb\\(var\\(--c-5796ff\\2c 87_150_255\\)\\/0\\.4\\)\\2c transparent_40\\%\\)\\2c linear-gradient\\(135deg\\2c rgb\\(var\\(--c-8f6dff\\2c 143_109_255\\)\\)\\2c rgb\\(var\\(--c-5f68d9\\2c 95_104_217\\)\\)_38\\%\\2c rgb\\(var\\(--c-4c79d7\\2c 76_121_215\\)\\)\\)\\]{
  background-image: radial-gradient(circle at 78% 64%,rgb(var(--c-5796ff,87 150 255)/0.4),transparent 40%),linear-gradient(135deg,rgb(var(--c-8f6dff,143 109 255)),rgb(var(--c-5f68d9,95 104 217)) 38%,rgb(var(--c-4c79d7,76 121 215)));
}
.bg-\\[radial-gradient\\(circle_at_85\\%_15\\%\\2c rgb\\(var\\(--c-e4ecff\\2c 228_236_255\\)\\/0\\.75\\)\\2c transparent_36\\%\\)\\2c linear-gradient\\(145deg\\2c rgb\\(var\\(--c-d8e4ff\\2c 216_228_255\\)\\)\\2c rgb\\(var\\(--c-aac0ef\\2c 170_192_239\\)\\)_62\\%\\2c rgb\\(var\\(--c-84a2df\\2c 132_162_223\\)\\)\\)\\]{
  background-image: radial-gradient(circle at 85% 15%,rgb(var(--c-e4ecff,228 236 255)/0.75),transparent 36%),linear-gradient(145deg,rgb(var(--c-d8e4ff,216 228 255)),rgb(var(--c-aac0ef,170 192 239)) 62%,rgb(var(--c-84a2df,132 162 223)));
}
.bg-\\[radial-gradient\\(ellipse_at_center\\2c rgb\\(var\\(--c-dbd2ec\\2c 219_210_236\\)\\/0\\.52\\)_0\\%\\2c rgb\\(var\\(--c-dbd2ec\\2c 219_210_236\\)\\/0\\)_74\\%\\)\\]{
  background-image: radial-gradient(ellipse at center,rgb(var(--c-dbd2ec,219 210 236)/0.52) 0%,rgb(var(--c-dbd2ec,219 210 236)/0) 74%);
}
.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-\\[\\#bc1888\\]{
  --tw-gradient-from: #bc1888 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(188 24 136 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-agentic-accent-purple{
  --tw-gradient-from: rgb(var(--agentic-accent-purple, 139 92 246) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--agentic-accent-purple, 139 92 246) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-agentic-primary-blue{
  --tw-gradient-from: rgb(var(--agentic-primary-blue, 30 58 138) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--agentic-primary-blue, 30 58 138) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-agentic-primary-blue\\/20{
  --tw-gradient-from: rgb(var(--agentic-primary-blue, 30 58 138) / 0.2) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-agentic-text-primary{
  --tw-gradient-from: rgb(var(--agentic-text-primary, 31 41 55) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--agentic-text-primary, 31 41 55) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-agentic-white-off{
  --tw-gradient-from: rgb(var(--agentic-white-off, 248 250 252) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--agentic-white-off, 248 250 252) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-amber-500{
  --tw-gradient-from: #f59e0b var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(245 158 11 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-200{
  --tw-gradient-from: rgb(var(--tw-blue-200, 191 219 254) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--tw-blue-200, 191 219 254) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-400{
  --tw-gradient-from: rgb(var(--tw-blue-400, 96 165 250) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--tw-blue-400, 96 165 250) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-50{
  --tw-gradient-from: rgb(var(--tw-blue-50, 239 246 255) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--tw-blue-50, 239 246 255) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-500{
  --tw-gradient-from: rgb(var(--tw-blue-500, 59 130 246) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--tw-blue-500, 59 130 246) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-blue-600{
  --tw-gradient-from: rgb(var(--tw-blue-600, 37 99 235) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--tw-blue-600, 37 99 235) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-c-2b2458{
  --tw-gradient-from: rgb(var(--c-2b2458, 43 36 88) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--c-2b2458, 43 36 88) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-c-805dc6{
  --tw-gradient-from: rgb(var(--c-805dc6, 128 93 198) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--c-805dc6, 128 93 198) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-cyan-500{
  --tw-gradient-from: #06b6d4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(6 182 212 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-emerald-500{
  --tw-gradient-from: #10b981 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(16 185 129 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-fuchsia-50{
  --tw-gradient-from: #fdf4ff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(253 244 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-50{
  --tw-gradient-from: rgb(var(--tw-gray-50, 249 250 251) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--tw-gray-50, 249 250 251) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-50{
  --tw-gradient-from: #f0fdf4 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(240 253 244 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-500{
  --tw-gradient-from: #22c55e var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(34 197 94 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-600{
  --tw-gradient-from: #16a34a var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(22 163 74 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-indigo-500{
  --tw-gradient-from: rgb(var(--tw-indigo-500, 99 102 241) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--tw-indigo-500, 99 102 241) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-kv-agentic-purple{
  --tw-gradient-from: rgb(var(--kv-agentic-purple, 128 93 198) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--kv-agentic-purple, 128 93 198) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-orange-500{
  --tw-gradient-from: #f97316 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(249 115 22 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-pink-500{
  --tw-gradient-from: #ec4899 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(236 72 153 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-50{
  --tw-gradient-from: rgb(var(--tw-purple-50, 250 245 255) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--tw-purple-50, 250 245 255) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-500{
  --tw-gradient-from: rgb(var(--tw-purple-500, 168 85 247) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--tw-purple-500, 168 85 247) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-red-500{
  --tw-gradient-from: #ef4444 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(239 68 68 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-teal-500{
  --tw-gradient-from: #14b8a6 var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(20 184 166 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-white{
  --tw-gradient-from: #fff var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(255 255 255 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.via-agentic-primary-blue{
  --tw-gradient-to: rgb(var(--agentic-primary-blue, 30 58 138) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--agentic-primary-blue, 30 58 138) / 1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-agentic-primary-blue\\/5{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--agentic-primary-blue, 30 58 138) / 0.05) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-blue-300{
  --tw-gradient-to: rgb(var(--tw-blue-300, 147 197 253) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--tw-blue-300, 147 197 253) / 1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-c-4b63c9{
  --tw-gradient-to: rgb(var(--c-4b63c9, 75 99 201) / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(var(--c-4b63c9, 75 99 201) / 1) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-orange-50\\/80{
  --tw-gradient-to: rgb(255 247 237 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 247 237 / 0.8) var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.via-white{
  --tw-gradient-to: rgb(255 255 255 / 0)  var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), #fff var(--tw-gradient-via-position), var(--tw-gradient-to);
}
.to-\\[\\#f09433\\]{
  --tw-gradient-to: #f09433 var(--tw-gradient-to-position);
}
.to-agentic-accent-purple{
  --tw-gradient-to: rgb(var(--agentic-accent-purple, 139 92 246) / 1) var(--tw-gradient-to-position);
}
.to-agentic-accent-purple\\/10{
  --tw-gradient-to: rgb(var(--agentic-accent-purple, 139 92 246) / 0.1) var(--tw-gradient-to-position);
}
.to-agentic-primary-blue-light{
  --tw-gradient-to: rgb(var(--agentic-primary-blue-light, 59 130 246) / 1) var(--tw-gradient-to-position);
}
.to-agentic-primary-blue-light\\/20{
  --tw-gradient-to: rgb(var(--agentic-primary-blue-light, 59 130 246) / 0.2) var(--tw-gradient-to-position);
}
.to-amber-50\\/90{
  --tw-gradient-to: rgb(255 251 235 / 0.9) var(--tw-gradient-to-position);
}
.to-amber-600{
  --tw-gradient-to: #d97706 var(--tw-gradient-to-position);
}
.to-blue-400{
  --tw-gradient-to: rgb(var(--tw-blue-400, 96 165 250) / 1) var(--tw-gradient-to-position);
}
.to-blue-50{
  --tw-gradient-to: rgb(var(--tw-blue-50, 239 246 255) / 1) var(--tw-gradient-to-position);
}
.to-blue-600{
  --tw-gradient-to: rgb(var(--tw-blue-600, 37 99 235) / 1) var(--tw-gradient-to-position);
}
.to-c-3683c6{
  --tw-gradient-to: rgb(var(--c-3683c6, 54 131 198) / 1) var(--tw-gradient-to-position);
}
.to-c-3c95d9{
  --tw-gradient-to: rgb(var(--c-3c95d9, 60 149 217) / 1) var(--tw-gradient-to-position);
}
.to-cyan-600{
  --tw-gradient-to: #0891b2 var(--tw-gradient-to-position);
}
.to-emerald-50{
  --tw-gradient-to: #ecfdf5 var(--tw-gradient-to-position);
}
.to-emerald-600{
  --tw-gradient-to: #059669 var(--tw-gradient-to-position);
}
.to-green-600{
  --tw-gradient-to: #16a34a var(--tw-gradient-to-position);
}
.to-indigo-50{
  --tw-gradient-to: rgb(var(--tw-indigo-50, 238 242 255) / 1) var(--tw-gradient-to-position);
}
.to-indigo-600{
  --tw-gradient-to: rgb(var(--tw-indigo-600, 79 70 229) / 1) var(--tw-gradient-to-position);
}
.to-kv-agentic-blue{
  --tw-gradient-to: rgb(var(--kv-agentic-blue, 54 131 198) / 1) var(--tw-gradient-to-position);
}
.to-orange-600{
  --tw-gradient-to: #ea580c var(--tw-gradient-to-position);
}
.to-pink-50{
  --tw-gradient-to: #fdf2f8 var(--tw-gradient-to-position);
}
.to-pink-600{
  --tw-gradient-to: #db2777 var(--tw-gradient-to-position);
}
.to-purple-600{
  --tw-gradient-to: rgb(var(--tw-purple-600, 147 51 234) / 1) var(--tw-gradient-to-position);
}
.to-red-600{
  --tw-gradient-to: #dc2626 var(--tw-gradient-to-position);
}
.to-teal-600{
  --tw-gradient-to: #0d9488 var(--tw-gradient-to-position);
}
.to-violet-50{
  --tw-gradient-to: rgb(var(--tw-violet-50, 245 243 255) / 1) var(--tw-gradient-to-position);
}
.to-violet-50\\/40{
  --tw-gradient-to: rgb(var(--tw-violet-50, 245 243 255) / 0.4) var(--tw-gradient-to-position);
}
.bg-cover{
  background-size: cover;
}
.bg-clip-text{
  background-clip: text;
}
.bg-center{
  background-position: center;
}
.object-contain{
  object-fit: contain;
}
.object-cover{
  object-fit: cover;
}
.p-0{
  padding: 0px;
}
.p-0\\.5{
  padding: 0.125rem;
}
.p-1{
  padding: 0.25rem;
}
.p-1\\.5{
  padding: 0.375rem;
}
.p-10{
  padding: 2.5rem;
}
.p-12{
  padding: 3rem;
}
.p-2{
  padding: 0.5rem;
}
.p-2\\.5{
  padding: 0.625rem;
}
.p-3{
  padding: 0.75rem;
}
.p-3\\.5{
  padding: 0.875rem;
}
.p-4{
  padding: 1rem;
}
.p-5{
  padding: 1.25rem;
}
.p-6{
  padding: 1.5rem;
}
.p-8{
  padding: 2rem;
}
.px-0{
  padding-left: 0px;
  padding-right: 0px;
}
.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5{
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5{
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[22px\\]{
  padding-left: 22px;
  padding-right: 22px;
}
.px-\\[30px\\]{
  padding-left: 30px;
  padding-right: 30px;
}
.py-0{
  padding-top: 0px;
  padding-bottom: 0px;
}
.py-0\\.5{
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5{
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5{
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5{
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}
.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[16px\\]{
  padding-top: 16px;
  padding-bottom: 16px;
}
.pb-0{
  padding-bottom: 0px;
}
.pb-0\\.5{
  padding-bottom: 0.125rem;
}
.pb-1{
  padding-bottom: 0.25rem;
}
.pb-10{
  padding-bottom: 2.5rem;
}
.pb-14{
  padding-bottom: 3.5rem;
}
.pb-16{
  padding-bottom: 4rem;
}
.pb-2{
  padding-bottom: 0.5rem;
}
.pb-2\\.5{
  padding-bottom: 0.625rem;
}
.pb-3{
  padding-bottom: 0.75rem;
}
.pb-4{
  padding-bottom: 1rem;
}
.pb-5{
  padding-bottom: 1.25rem;
}
.pb-6{
  padding-bottom: 1.5rem;
}
.pb-8{
  padding-bottom: 2rem;
}
.pb-\\[9px\\]{
  padding-bottom: 9px;
}
.pb-\\[max\\(env\\(safe-area-inset-bottom\\)\\2c 0rem\\)\\]{
  padding-bottom: max(env(safe-area-inset-bottom), 0rem);
}
.pl-0{
  padding-left: 0px;
}
.pl-10{
  padding-left: 2.5rem;
}
.pl-2{
  padding-left: 0.5rem;
}
.pl-3{
  padding-left: 0.75rem;
}
.pl-4{
  padding-left: 1rem;
}
.pl-5{
  padding-left: 1.25rem;
}
.pr-0{
  padding-right: 0px;
}
.pr-0\\.5{
  padding-right: 0.125rem;
}
.pr-1{
  padding-right: 0.25rem;
}
.pr-10{
  padding-right: 2.5rem;
}
.pr-11{
  padding-right: 2.75rem;
}
.pr-16{
  padding-right: 4rem;
}
.pr-2{
  padding-right: 0.5rem;
}
.pr-20{
  padding-right: 5rem;
}
.pr-24{
  padding-right: 6rem;
}
.pr-3{
  padding-right: 0.75rem;
}
.pr-4{
  padding-right: 1rem;
}
.pr-6{
  padding-right: 1.5rem;
}
.pt-0{
  padding-top: 0px;
}
.pt-1{
  padding-top: 0.25rem;
}
.pt-1\\.5{
  padding-top: 0.375rem;
}
.pt-2{
  padding-top: 0.5rem;
}
.pt-2\\.5{
  padding-top: 0.625rem;
}
.pt-3{
  padding-top: 0.75rem;
}
.pt-4{
  padding-top: 1rem;
}
.pt-5{
  padding-top: 1.25rem;
}
.pt-6{
  padding-top: 1.5rem;
}
.pt-8{
  padding-top: 2rem;
}
.pt-\\[104px\\]{
  padding-top: 104px;
}
.pt-\\[26px\\]{
  padding-top: 26px;
}
.pt-\\[env\\(safe-area-inset-top\\)\\]{
  padding-top: env(safe-area-inset-top);
}
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
.text-right{
  text-align: right;
}
.text-end{
  text-align: end;
}
.align-top{
  vertical-align: top;
}
.font-mono{
  font-family: JetBrains Mono, Fira Code, Consolas, monospace;
}
.text-2xl{
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl{
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl{
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-5xl{
  font-size: 3rem;
  line-height: 1;
}
.text-6xl{
  font-size: 3.75rem;
  line-height: 1;
}
.text-9xl{
  font-size: 8rem;
  line-height: 1;
}
.text-\\[0\\.9rem\\]{
  font-size: 0.9rem;
}
.text-\\[1\\.05rem\\]{
  font-size: 1.05rem;
}
.text-\\[1\\.1rem\\]{
  font-size: 1.1rem;
}
.text-\\[1\\.25rem\\]{
  font-size: 1.25rem;
}
.text-\\[1\\.2rem\\]{
  font-size: 1.2rem;
}
.text-\\[1\\.35rem\\]{
  font-size: 1.35rem;
}
.text-\\[1\\.55rem\\]{
  font-size: 1.55rem;
}
.text-\\[1\\.5rem\\]{
  font-size: 1.5rem;
}
.text-\\[1\\.6rem\\]{
  font-size: 1.6rem;
}
.text-\\[10px\\]{
  font-size: 10px;
}
.text-\\[11px\\]{
  font-size: 11px;
}
.text-\\[12px\\]{
  font-size: 12px;
}
.text-\\[15px\\]{
  font-size: 15px;
}
.text-\\[16px\\]{
  font-size: 16px;
}
.text-\\[1rem\\]{
  font-size: 1rem;
}
.text-\\[2\\.25rem\\]{
  font-size: 2.25rem;
}
.text-\\[2\\.3rem\\]{
  font-size: 2.3rem;
}
.text-\\[2\\.4rem\\]{
  font-size: 2.4rem;
}
.text-\\[2\\.5rem\\]{
  font-size: 2.5rem;
}
.text-\\[2\\.625rem\\]{
  font-size: 2.625rem;
}
.text-\\[24px\\]{
  font-size: 24px;
}
.text-\\[2rem\\]{
  font-size: 2rem;
}
.text-\\[3\\.25rem\\]{
  font-size: 3.25rem;
}
.text-\\[3rem\\]{
  font-size: 3rem;
}
.text-\\[4\\.1rem\\]{
  font-size: 4.1rem;
}
.text-\\[4\\.4rem\\]{
  font-size: 4.4rem;
}
.text-\\[4\\.8rem\\]{
  font-size: 4.8rem;
}
.text-\\[5\\.5rem\\]{
  font-size: 5.5rem;
}
.text-\\[9px\\]{
  font-size: 9px;
}
.text-base{
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-display-lg{
  font-size: 2.35rem;
  line-height: 1.05;
  font-weight: 600;
}
.text-lg{
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm{
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-title-md{
  font-size: 1.5rem;
  line-height: 1.25;
  font-weight: 500;
}
.text-xl{
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs{
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold{
  font-weight: 700;
}
.font-light{
  font-weight: 300;
}
.font-medium{
  font-weight: 500;
}
.font-normal{
  font-weight: 400;
}
.font-semibold{
  font-weight: 600;
}
.uppercase{
  text-transform: uppercase;
}
.lowercase{
  text-transform: lowercase;
}
.capitalize{
  text-transform: capitalize;
}
.normal-case{
  text-transform: none;
}
.italic{
  font-style: italic;
}
.tabular-nums{
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-4{
  line-height: 1rem;
}
.leading-5{
  line-height: 1.25rem;
}
.leading-6{
  line-height: 1.5rem;
}
.leading-8{
  line-height: 2rem;
}
.leading-\\[1\\.08\\]{
  line-height: 1.08;
}
.leading-\\[1\\.12\\]{
  line-height: 1.12;
}
.leading-\\[1\\.1\\]{
  line-height: 1.1;
}
.leading-\\[1\\.25\\]{
  line-height: 1.25;
}
.leading-\\[1\\.2\\]{
  line-height: 1.2;
}
.leading-none{
  line-height: 1;
}
.leading-normal{
  line-height: 1.5;
}
.leading-relaxed{
  line-height: 1.625;
}
.leading-snug{
  line-height: 1.375;
}
.leading-tight{
  line-height: 1.25;
}
.tracking-\\[0\\.12em\\]{
  letter-spacing: 0.12em;
}
.tracking-\\[0\\.14em\\]{
  letter-spacing: 0.14em;
}
.tracking-\\[0\\.18em\\]{
  letter-spacing: 0.18em;
}
.tracking-tight{
  letter-spacing: -0.025em;
}
.tracking-wide{
  letter-spacing: 0.025em;
}
.tracking-wider{
  letter-spacing: 0.05em;
}
.tracking-widest{
  letter-spacing: 0.1em;
}
.text-\\[\\#13b546\\]{
  --tw-text-opacity: 1;
  color: rgb(19 181 70 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1877F2\\]{
  --tw-text-opacity: 1;
  color: rgb(24 119 242 / var(--tw-text-opacity, 1));
}
.text-\\[\\#1f8f44\\]{
  --tw-text-opacity: 1;
  color: rgb(31 143 68 / var(--tw-text-opacity, 1));
}
.text-\\[\\#A9F6C8\\]{
  --tw-text-opacity: 1;
  color: rgb(169 246 200 / var(--tw-text-opacity, 1));
}
.text-\\[\\#d92e2e\\]{
  --tw-text-opacity: 1;
  color: rgb(217 46 46 / var(--tw-text-opacity, 1));
}
.text-\\[rgb\\(var\\(--theme-footer-muted\\2c var\\(--c-3f3a63\\2c 63_58_99\\)\\)\\)\\]{
  color: rgb(var(--theme-footer-muted,var(--c-3f3a63,63 58 99)));
}
.text-\\[rgb\\(var\\(--theme-footer-muted\\2c var\\(--c-4f4b6f\\2c 79_75_111\\)\\)\\)\\]{
  color: rgb(var(--theme-footer-muted,var(--c-4f4b6f,79 75 111)));
}
.text-\\[rgb\\(var\\(--theme-footer-muted\\2c var\\(--c-d2d7ea\\2c 210_215_234\\)\\)\\)\\]{
  color: rgb(var(--theme-footer-muted,var(--c-d2d7ea,210 215 234)));
}
.text-\\[rgb\\(var\\(--theme-footer-text\\2c var\\(--c-211b44\\2c 33_27_68\\)\\)\\)\\]{
  color: rgb(var(--theme-footer-text,var(--c-211b44,33 27 68)));
}
.text-agentic-accent-green{
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-accent-green, 16 185 129) / var(--tw-text-opacity, 1));
}
.text-agentic-accent-purple{
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-accent-purple, 139 92 246) / var(--tw-text-opacity, 1));
}
.text-agentic-accent-red{
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-accent-red, 239 68 68) / var(--tw-text-opacity, 1));
}
.text-agentic-accent-yellow{
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-accent-yellow, 245 158 11) / var(--tw-text-opacity, 1));
}
.text-agentic-gray-300{
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-gray-300, 209 213 219) / var(--tw-text-opacity, 1));
}
.text-agentic-gray-400{
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-gray-400, 156 163 175) / var(--tw-text-opacity, 1));
}
.text-agentic-primary-blue{
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-primary-blue, 30 58 138) / var(--tw-text-opacity, 1));
}
.text-agentic-text-muted{
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-text-muted, 156 163 175) / var(--tw-text-opacity, 1));
}
.text-agentic-text-primary{
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-text-primary, 31 41 55) / var(--tw-text-opacity, 1));
}
.text-agentic-text-secondary{
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-text-secondary, 107 114 128) / var(--tw-text-opacity, 1));
}
.text-agentic-text-secondary\\/80{
  color: rgb(var(--agentic-text-secondary, 107 114 128) / 0.8);
}
.text-amber-300{
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-amber-500{
  --tw-text-opacity: 1;
  color: rgb(245 158 11 / var(--tw-text-opacity, 1));
}
.text-amber-600{
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700{
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800{
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-amber-900{
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-amber-900\\/90{
  color: rgb(120 53 15 / 0.9);
}
.text-amber-950{
  --tw-text-opacity: 1;
  color: rgb(69 26 3 / var(--tw-text-opacity, 1));
}
.text-black{
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-500{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-blue-500, 59 130 246) / var(--tw-text-opacity, 1));
}
.text-blue-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-blue-600, 37 99 235) / var(--tw-text-opacity, 1));
}
.text-blue-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-blue-700, 29 78 216) / var(--tw-text-opacity, 1));
}
.text-blue-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-blue-800, 30 64 175) / var(--tw-text-opacity, 1));
}
.text-blue-900{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-blue-900, 30 58 138) / var(--tw-text-opacity, 1));
}
.text-c-0052a3{
  --tw-text-opacity: 1;
  color: rgb(var(--c-0052a3, 0 82 163) / var(--tw-text-opacity, 1));
}
.text-c-0066cc{
  --tw-text-opacity: 1;
  color: rgb(var(--c-0066cc, 0 102 204) / var(--tw-text-opacity, 1));
}
.text-c-111111{
  --tw-text-opacity: 1;
  color: rgb(var(--c-111111, 17 17 17) / var(--tw-text-opacity, 1));
}
.text-c-111323{
  --tw-text-opacity: 1;
  color: rgb(var(--c-111323, 17 19 35) / var(--tw-text-opacity, 1));
}
.text-c-12152a{
  --tw-text-opacity: 1;
  color: rgb(var(--c-12152a, 18 21 42) / var(--tw-text-opacity, 1));
}
.text-c-1a1a1a{
  --tw-text-opacity: 1;
  color: rgb(var(--c-1a1a1a, 26 26 26) / var(--tw-text-opacity, 1));
}
.text-c-1a1b2f{
  --tw-text-opacity: 1;
  color: rgb(var(--c-1a1b2f, 26 27 47) / var(--tw-text-opacity, 1));
}
.text-c-1f1f1f{
  --tw-text-opacity: 1;
  color: rgb(var(--c-1f1f1f, 31 31 31) / var(--tw-text-opacity, 1));
}
.text-c-1f1f1f\\/80{
  color: rgb(var(--c-1f1f1f, 31 31 31) / 0.8);
}
.text-c-1f2430{
  --tw-text-opacity: 1;
  color: rgb(var(--c-1f2430, 31 36 48) / var(--tw-text-opacity, 1));
}
.text-c-1f2447{
  --tw-text-opacity: 1;
  color: rgb(var(--c-1f2447, 31 36 71) / var(--tw-text-opacity, 1));
}
.text-c-20264d{
  --tw-text-opacity: 1;
  color: rgb(var(--c-20264d, 32 38 77) / var(--tw-text-opacity, 1));
}
.text-c-22284b{
  --tw-text-opacity: 1;
  color: rgb(var(--c-22284b, 34 40 75) / var(--tw-text-opacity, 1));
}
.text-c-2b2f36{
  --tw-text-opacity: 1;
  color: rgb(var(--c-2b2f36, 43 47 54) / var(--tw-text-opacity, 1));
}
.text-c-2e6ecf{
  --tw-text-opacity: 1;
  color: rgb(var(--c-2e6ecf, 46 110 207) / var(--tw-text-opacity, 1));
}
.text-c-2f3353{
  --tw-text-opacity: 1;
  color: rgb(var(--c-2f3353, 47 51 83) / var(--tw-text-opacity, 1));
}
.text-c-2f6dcb{
  --tw-text-opacity: 1;
  color: rgb(var(--c-2f6dcb, 47 109 203) / var(--tw-text-opacity, 1));
}
.text-c-30354f{
  --tw-text-opacity: 1;
  color: rgb(var(--c-30354f, 48 53 79) / var(--tw-text-opacity, 1));
}
.text-c-374067{
  --tw-text-opacity: 1;
  color: rgb(var(--c-374067, 55 64 103) / var(--tw-text-opacity, 1));
}
.text-c-3e4f99{
  --tw-text-opacity: 1;
  color: rgb(var(--c-3e4f99, 62 79 153) / var(--tw-text-opacity, 1));
}
.text-c-3f3a63{
  --tw-text-opacity: 1;
  color: rgb(var(--c-3f3a63, 63 58 99) / var(--tw-text-opacity, 1));
}
.text-c-3f4a78{
  --tw-text-opacity: 1;
  color: rgb(var(--c-3f4a78, 63 74 120) / var(--tw-text-opacity, 1));
}
.text-c-414865{
  --tw-text-opacity: 1;
  color: rgb(var(--c-414865, 65 72 101) / var(--tw-text-opacity, 1));
}
.text-c-4d58a8{
  --tw-text-opacity: 1;
  color: rgb(var(--c-4d58a8, 77 88 168) / var(--tw-text-opacity, 1));
}
.text-c-4f5665{
  --tw-text-opacity: 1;
  color: rgb(var(--c-4f5665, 79 86 101) / var(--tw-text-opacity, 1));
}
.text-c-53586b{
  --tw-text-opacity: 1;
  color: rgb(var(--c-53586b, 83 88 107) / var(--tw-text-opacity, 1));
}
.text-c-5a67e6{
  --tw-text-opacity: 1;
  color: rgb(var(--c-5a67e6, 90 103 230) / var(--tw-text-opacity, 1));
}
.text-c-5c4fcf{
  --tw-text-opacity: 1;
  color: rgb(var(--c-5c4fcf, 92 79 207) / var(--tw-text-opacity, 1));
}
.text-c-5d6377{
  --tw-text-opacity: 1;
  color: rgb(var(--c-5d6377, 93 99 119) / var(--tw-text-opacity, 1));
}
.text-c-5f6678{
  --tw-text-opacity: 1;
  color: rgb(var(--c-5f6678, 95 102 120) / var(--tw-text-opacity, 1));
}
.text-c-5f6775{
  --tw-text-opacity: 1;
  color: rgb(var(--c-5f6775, 95 103 117) / var(--tw-text-opacity, 1));
}
.text-c-5f79ce{
  --tw-text-opacity: 1;
  color: rgb(var(--c-5f79ce, 95 121 206) / var(--tw-text-opacity, 1));
}
.text-c-6e748c{
  --tw-text-opacity: 1;
  color: rgb(var(--c-6e748c, 110 116 140) / var(--tw-text-opacity, 1));
}
.text-c-6f6fbe{
  --tw-text-opacity: 1;
  color: rgb(var(--c-6f6fbe, 111 111 190) / var(--tw-text-opacity, 1));
}
.text-c-6f7281{
  --tw-text-opacity: 1;
  color: rgb(var(--c-6f7281, 111 114 129) / var(--tw-text-opacity, 1));
}
.text-c-6f74bd{
  --tw-text-opacity: 1;
  color: rgb(var(--c-6f74bd, 111 116 189) / var(--tw-text-opacity, 1));
}
.text-c-70768f{
  --tw-text-opacity: 1;
  color: rgb(var(--c-70768f, 112 118 143) / var(--tw-text-opacity, 1));
}
.text-c-7352d3{
  --tw-text-opacity: 1;
  color: rgb(var(--c-7352d3, 115 82 211) / var(--tw-text-opacity, 1));
}
.text-c-747a9d{
  --tw-text-opacity: 1;
  color: rgb(var(--c-747a9d, 116 122 157) / var(--tw-text-opacity, 1));
}
.text-c-7b8796{
  --tw-text-opacity: 1;
  color: rgb(var(--c-7b8796, 123 135 150) / var(--tw-text-opacity, 1));
}
.text-c-7e8da0{
  --tw-text-opacity: 1;
  color: rgb(var(--c-7e8da0, 126 141 160) / var(--tw-text-opacity, 1));
}
.text-c-7f58ca{
  --tw-text-opacity: 1;
  color: rgb(var(--c-7f58ca, 127 88 202) / var(--tw-text-opacity, 1));
}
.text-c-7f86aa{
  --tw-text-opacity: 1;
  color: rgb(var(--c-7f86aa, 127 134 170) / var(--tw-text-opacity, 1));
}
.text-c-7fe3ff{
  --tw-text-opacity: 1;
  color: rgb(var(--c-7fe3ff, 127 227 255) / var(--tw-text-opacity, 1));
}
.text-c-808080{
  --tw-text-opacity: 1;
  color: rgb(var(--c-808080, 128 128 128) / var(--tw-text-opacity, 1));
}
.text-c-8b9bf6{
  --tw-text-opacity: 1;
  color: rgb(var(--c-8b9bf6, 139 155 246) / var(--tw-text-opacity, 1));
}
.text-c-8e98a8{
  --tw-text-opacity: 1;
  color: rgb(var(--c-8e98a8, 142 152 168) / var(--tw-text-opacity, 1));
}
.text-c-8f95b4{
  --tw-text-opacity: 1;
  color: rgb(var(--c-8f95b4, 143 149 180) / var(--tw-text-opacity, 1));
}
.text-c-a3a9be{
  --tw-text-opacity: 1;
  color: rgb(var(--c-a3a9be, 163 169 190) / var(--tw-text-opacity, 1));
}
.text-c-b7b7b7{
  --tw-text-opacity: 1;
  color: rgb(var(--c-b7b7b7, 183 183 183) / var(--tw-text-opacity, 1));
}
.text-c-d6b8ff{
  --tw-text-opacity: 1;
  color: rgb(var(--c-d6b8ff, 214 184 255) / var(--tw-text-opacity, 1));
}
.text-emerald-400{
  --tw-text-opacity: 1;
  color: rgb(52 211 153 / var(--tw-text-opacity, 1));
}
.text-emerald-600{
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700{
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-900{
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-gray-300{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-gray-300, 209 213 219) / var(--tw-text-opacity, 1));
}
.text-gray-400{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-gray-400, 156 163 175) / var(--tw-text-opacity, 1));
}
.text-gray-500{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-gray-500, 107 114 128) / var(--tw-text-opacity, 1));
}
.text-gray-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-gray-600, 75 85 99) / var(--tw-text-opacity, 1));
}
.text-gray-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-gray-700, 55 65 81) / var(--tw-text-opacity, 1));
}
.text-gray-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-gray-800, 31 41 55) / var(--tw-text-opacity, 1));
}
.text-gray-900{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-gray-900, 17 24 39) / var(--tw-text-opacity, 1));
}
.text-green-300{
  --tw-text-opacity: 1;
  color: rgb(134 239 172 / var(--tw-text-opacity, 1));
}
.text-green-500{
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity, 1));
}
.text-green-600{
  --tw-text-opacity: 1;
  color: rgb(22 163 74 / var(--tw-text-opacity, 1));
}
.text-green-700{
  --tw-text-opacity: 1;
  color: rgb(21 128 61 / var(--tw-text-opacity, 1));
}
.text-green-800{
  --tw-text-opacity: 1;
  color: rgb(22 101 52 / var(--tw-text-opacity, 1));
}
.text-kv-agentic-blue{
  --tw-text-opacity: 1;
  color: rgb(var(--kv-agentic-blue, 54 131 198) / var(--tw-text-opacity, 1));
}
.text-kv-agentic-body{
  --tw-text-opacity: 1;
  color: rgb(var(--kv-agentic-body, 31 31 31) / var(--tw-text-opacity, 1));
}
.text-kv-agentic-cyan{
  --tw-text-opacity: 1;
  color: rgb(var(--kv-agentic-cyan, 75 186 227) / var(--tw-text-opacity, 1));
}
.text-kv-agentic-ink{
  --tw-text-opacity: 1;
  color: rgb(var(--kv-agentic-ink, 10 10 10) / var(--tw-text-opacity, 1));
}
.text-kv-agentic-ink\\/80{
  color: rgb(var(--kv-agentic-ink, 10 10 10) / 0.8);
}
.text-kv-agentic-purple{
  --tw-text-opacity: 1;
  color: rgb(var(--kv-agentic-purple, 128 93 198) / var(--tw-text-opacity, 1));
}
.text-kv-agentic-slate{
  --tw-text-opacity: 1;
  color: rgb(var(--kv-agentic-slate, 65 71 77) / var(--tw-text-opacity, 1));
}
.text-on-primary{
  --tw-text-opacity: 1;
  color: rgb(var(--theme-on-primary, 255 255 255) / var(--tw-text-opacity, 1));
}
.text-orange-600{
  --tw-text-opacity: 1;
  color: rgb(234 88 12 / var(--tw-text-opacity, 1));
}
.text-orange-700{
  --tw-text-opacity: 1;
  color: rgb(194 65 12 / var(--tw-text-opacity, 1));
}
.text-pink-700{
  --tw-text-opacity: 1;
  color: rgb(190 24 93 / var(--tw-text-opacity, 1));
}
.text-purple-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-purple-600, 147 51 234) / var(--tw-text-opacity, 1));
}
.text-purple-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-purple-700, 126 34 206) / var(--tw-text-opacity, 1));
}
.text-red-400{
  --tw-text-opacity: 1;
  color: rgb(248 113 113 / var(--tw-text-opacity, 1));
}
.text-red-500{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-red-600{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-rose-400{
  --tw-text-opacity: 1;
  color: rgb(251 113 133 / var(--tw-text-opacity, 1));
}
.text-rose-600{
  --tw-text-opacity: 1;
  color: rgb(225 29 72 / var(--tw-text-opacity, 1));
}
.text-rose-700{
  --tw-text-opacity: 1;
  color: rgb(190 18 60 / var(--tw-text-opacity, 1));
}
.text-sky-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-sky-700, 3 105 161) / var(--tw-text-opacity, 1));
}
.text-sky-900{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-sky-900, 12 74 110) / var(--tw-text-opacity, 1));
}
.text-slate-400{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-slate-400, 148 163 184) / var(--tw-text-opacity, 1));
}
.text-slate-500{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-slate-500, 100 116 139) / var(--tw-text-opacity, 1));
}
.text-slate-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-slate-600, 71 85 105) / var(--tw-text-opacity, 1));
}
.text-slate-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-slate-700, 51 65 85) / var(--tw-text-opacity, 1));
}
.text-slate-800{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-slate-800, 30 41 59) / var(--tw-text-opacity, 1));
}
.text-slate-900{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-slate-900, 15 23 42) / var(--tw-text-opacity, 1));
}
.text-teal-700{
  --tw-text-opacity: 1;
  color: rgb(15 118 110 / var(--tw-text-opacity, 1));
}
.text-transparent{
  color: transparent;
}
.text-violet-600{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-violet-600, 124 58 237) / var(--tw-text-opacity, 1));
}
.text-violet-700{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-violet-700, 109 40 217) / var(--tw-text-opacity, 1));
}
.text-violet-900{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-violet-900, 76 29 149) / var(--tw-text-opacity, 1));
}
.text-white{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/25{
  color: rgb(255 255 255 / 0.25);
}
.text-white\\/60{
  color: rgb(255 255 255 / 0.6);
}
.text-white\\/65{
  color: rgb(255 255 255 / 0.65);
}
.text-white\\/70{
  color: rgb(255 255 255 / 0.7);
}
.text-white\\/75{
  color: rgb(255 255 255 / 0.75);
}
.text-white\\/80{
  color: rgb(255 255 255 / 0.8);
}
.text-white\\/85{
  color: rgb(255 255 255 / 0.85);
}
.text-white\\/90{
  color: rgb(255 255 255 / 0.9);
}
.text-yellow-500{
  --tw-text-opacity: 1;
  color: rgb(234 179 8 / var(--tw-text-opacity, 1));
}
.text-yellow-600{
  --tw-text-opacity: 1;
  color: rgb(202 138 4 / var(--tw-text-opacity, 1));
}
.text-yellow-700{
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.text-yellow-800{
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.underline{
  text-decoration-line: underline;
}
.underline-offset-2{
  text-underline-offset: 2px;
}
.placeholder-agentic-text-muted::placeholder{
  --tw-placeholder-opacity: 1;
  color: rgb(var(--agentic-text-muted, 156 163 175) / var(--tw-placeholder-opacity, 1));
}
.opacity-0{
  opacity: 0;
}
.opacity-10{
  opacity: 0.1;
}
.opacity-100{
  opacity: 1;
}
.opacity-20{
  opacity: 0.2;
}
.opacity-50{
  opacity: 0.5;
}
.opacity-55{
  opacity: 0.55;
}
.opacity-60{
  opacity: 0.6;
}
.opacity-70{
  opacity: 0.7;
}
.opacity-80{
  opacity: 0.8;
}
.shadow{
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-2xl{
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_1px_rgb\\(var\\(--c-8b5cf6\\2c 139_92_246\\)\\/0\\.35\\)\\]{
  --tw-shadow: 0 0 0 1px rgb(var(--c-8b5cf6,139 92 246)/0.35);
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_12px_28px_rgb\\(var\\(--c-272e5c\\2c 39_46_92\\)\\/0\\.12\\)\\]{
  --tw-shadow: 0 12px 28px rgb(var(--c-272e5c,39 46 92)/0.12);
  --tw-shadow-colored: 0 12px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_18px_45px_rgb\\(var\\(--c-0f172a\\2c 15_23_42\\)\\/0\\.12\\)\\]{
  --tw-shadow: 0 18px 45px rgb(var(--c-0f172a,15 23 42)/0.12);
  --tw-shadow-colored: 0 18px 45px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_0_rgb\\(var\\(--c-3a5498\\2c 58_84_152\\)\\/0\\.08\\)\\]{
  --tw-shadow: 0 1px 0 rgb(var(--c-3a5498,58 84 152)/0.08);
  --tw-shadow-colored: 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_0_rgb\\(var\\(--c-e9ebf3\\2c 233_235_243\\)\\)\\]{
  --tw-shadow: 0 1px 0 rgb(var(--c-e9ebf3,233 235 243));
  --tw-shadow-colored: 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_45px_rgb\\(var\\(--c-0c1446\\2c 12_20_70\\)\\/0\\.45\\)\\]{
  --tw-shadow: 0 20px 45px rgb(var(--c-0c1446,12 20 70)/0.45);
  --tw-shadow-colored: 0 20px 45px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_45px_rgb\\(var\\(--c-1c2350\\2c 28_35_80\\)\\/0\\.08\\)\\]{
  --tw-shadow: 0 20px 45px rgb(var(--c-1c2350,28 35 80)/0.08);
  --tw-shadow-colored: 0 20px 45px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_20px_60px_rgb\\(var\\(--c-080a14\\2c 8_10_20\\)\\/0\\.35\\)\\]{
  --tw-shadow: 0 20px 60px rgb(var(--c-080a14,8 10 20)/0.35);
  --tw-shadow-colored: 0 20px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-card{
  --tw-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-floating{
  --tw-shadow: 0 12px 28px rgba(39,46,92,0.12);
  --tw-shadow-colored: 0 12px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner{
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none{
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-blue-100{
  --tw-shadow-color: rgb(var(--tw-blue-100, 219 234 254) / 1);
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline{
  outline-style: solid;
}
.outline-white{
  outline-color: #fff;
}
.ring{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-1{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-2{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-inset{
  --tw-ring-inset: inset;
}
.ring-agentic-gray-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--agentic-gray-200, 229 231 235) / var(--tw-ring-opacity, 1));
}
.ring-amber-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(253 230 138 / var(--tw-ring-opacity, 1));
}
.ring-blue-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--tw-blue-200, 191 219 254) / var(--tw-ring-opacity, 1));
}
.ring-gray-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--tw-gray-200, 229 231 235) / var(--tw-ring-opacity, 1));
}
.ring-green-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(187 247 208 / var(--tw-ring-opacity, 1));
}
.ring-purple-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--tw-purple-200, 233 213 255) / var(--tw-ring-opacity, 1));
}
.ring-red-200{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(254 202 202 / var(--tw-ring-opacity, 1));
}
.ring-white{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}
.blur-3xl{
  --tw-blur: blur(64px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.grayscale{
  --tw-grayscale: grayscale(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert{
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter{
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur{
  --tw-backdrop-blur: blur(8px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-\\[2px\\]{
  --tw-backdrop-blur: blur(2px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-nav{
  --tw-backdrop-blur: blur(15px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.backdrop-blur-sm{
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.\\!transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
  transition-duration: 150ms !important;
}
.transition{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all{
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors{
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity{
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow{
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform{
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200{
  transition-duration: 200ms;
}
.duration-300{
  transition-duration: 300ms;
}
.ease-agentic{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\[-webkit-text-stroke\\:1\\.6px_\\#8fa4ef\\]{
  -webkit-text-stroke: 1.6px #8fa4ef;
}
.\\[-webkit-text-stroke\\:2px_\\#b7bdf1\\]{
  -webkit-text-stroke: 2px #b7bdf1;
}
.\\[transform\\:rotate\\(180deg\\)\\]{
  transform: rotate(180deg);
}
.\\[writing-mode\\:vertical-rl\\]{
  writing-mode: vertical-rl;
}

/*
 * Theme.
 *
 * Every colour class reads a CSS custom property with today's colour as its
 * fallback (see tailwind.config.js and src/theme/tokens.json). The theme engine
 * (src/theme/engine.ts) sets those properties from the tenant's or product's
 * colours; when nothing is set, the fallbacks apply and nothing changes.
 */

.message-content ol,
.message-content ul {
  list-style: revert;
  margin-left: 1.5em;
}

.message-content h1,
.message-content h2 {
  color: rgb(var(--c-1a1a1a, 26 26 26));
  font-weight: 700;
  margin-bottom: 20px;
}

.message-content h1 {
  font-size: 1.4rem;
  line-height: 1.4;
}

.message-content h2 {
  font-size: 1.2rem;
  line-height: 1.4;
}

.message-content p {
  margin-bottom: 16px;
  font-size: 0.95rem;
}

.message-content ul {
  margin: 12px 0;
  padding-left: 20px;
}

.message-content ul li {
  margin-bottom: 8px;
}

.message-content strong {
  font-weight: 600;
  color: rgb(var(--agentic-primary-blue, 30 58 138));
}

/* \`color: inherit\` (not the fixed brand blue used for \`strong\`) deliberately — this class is
 * shared by both the bot's white bubble and the user's own colored/gradient bubble, and a fixed
 * color reads fine on white but loses contrast against a colored bubble. Underline + bold weight
 * alone is enough to read as a link against either background, with no contrast risk. */
.message-content a {
  color: inherit;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
  word-break: break-word;
}

.message-content a:hover {
  opacity: 0.75;
}

.message-content blockquote {
  font-style: italic;
  color: rgb(var(--c-555555, 85 85 85));
  margin: 20px 0;
  padding-left: 20px;
  border-left: 4px solid rgb(var(--c-cccccc, 204 204 204));
}

.placeholder\\:text-sm::placeholder{
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.placeholder\\:text-agentic-text-muted::placeholder{
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-text-muted, 156 163 175) / var(--tw-text-opacity, 1));
}

.placeholder\\:text-c-9095a9::placeholder{
  --tw-text-opacity: 1;
  color: rgb(var(--c-9095a9, 144 149 169) / var(--tw-text-opacity, 1));
}

.focus-within\\:border-kv-agentic-blue:focus-within{
  --tw-border-opacity: 1;
  border-color: rgb(var(--kv-agentic-blue, 54 131 198) / var(--tw-border-opacity, 1));
}

.focus-within\\:border-transparent:focus-within{
  border-color: transparent;
}

.focus-within\\:ring-2:focus-within{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-within\\:ring-agentic-primary-blue:focus-within{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--agentic-primary-blue, 30 58 138) / var(--tw-ring-opacity, 1));
}

.focus-within\\:ring-kv-agentic-blue\\/20:focus-within{
  --tw-ring-color: rgb(var(--kv-agentic-blue, 54 131 198) / 0.2);
}

.hover\\:-translate-y-1:hover{
  --tw-translate-y: -0.25rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-105:hover{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:scale-110:hover{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-agentic-gray-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--agentic-gray-300, 209 213 219) / var(--tw-border-opacity, 1));
}

.hover\\:border-agentic-primary-blue:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--agentic-primary-blue, 30 58 138) / var(--tw-border-opacity, 1));
}

.hover\\:border-blue-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-blue-300, 147 197 253) / var(--tw-border-opacity, 1));
}

.hover\\:border-blue-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-blue-400, 96 165 250) / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-gray-300, 209 213 219) / var(--tw-border-opacity, 1));
}

.hover\\:border-gray-400:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-gray-400, 156 163 175) / var(--tw-border-opacity, 1));
}

.hover\\:border-kv-agentic-blue:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--kv-agentic-blue, 54 131 198) / var(--tw-border-opacity, 1));
}

.hover\\:border-red-300:hover{
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}

.hover\\:border-violet-200:hover{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-violet-200, 221 214 254) / var(--tw-border-opacity, 1));
}

.hover\\:bg-agentic-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-gray-100, 243 244 246) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-agentic-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-gray-200, 229 231 235) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-agentic-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-gray-50, 249 250 251) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-agentic-primary-blue-dark:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-primary-blue-dark, 30 64 175) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-agentic-primary-blue\\/5:hover{
  background-color: rgb(var(--agentic-primary-blue, 30 58 138) / 0.05);
}

.hover\\:bg-agentic-primary-blue\\/90:hover{
  background-color: rgb(var(--agentic-primary-blue, 30 58 138) / 0.9);
}

.hover\\:bg-amber-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-amber-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-blue-100, 219 234 254) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-400:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-blue-400, 96 165 250) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-blue-50, 239 246 255) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-50\\/30:hover{
  background-color: rgb(var(--tw-blue-50, 239 246 255) / 0.3);
}

.hover\\:bg-blue-50\\/50:hover{
  background-color: rgb(var(--tw-blue-50, 239 246 255) / 0.5);
}

.hover\\:bg-blue-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-blue-700, 29 78 216) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-blue-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-blue-800, 30 64 175) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-c-0052a3:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-0052a3, 0 82 163) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-c-0066cc:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-0066cc, 0 102 204) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-c-f0f2f5:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-f0f2f5, 240 242 245) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-c-f4f6fe:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-f4f6fe, 244 246 254) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-c-f4f8ff:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-f4f8ff, 244 248 255) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-c-f8fbff:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-f8fbff, 248 251 255) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-emerald-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-gray-100, 243 244 246) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-200:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-gray-200, 229 231 235) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-gray-50, 249 250 251) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-800:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-gray-800, 31 41 55) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(240 253 244 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(21 128 61 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-purple-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-purple-700, 126 34 206) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-100:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-50:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-red-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-violet-700:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--tw-violet-700, 109 40 217) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-white\\/20:hover{
  background-color: rgb(255 255 255 / 0.2);
}

.hover\\:bg-white\\/60:hover{
  background-color: rgb(255 255 255 / 0.6);
}

.hover\\:bg-yellow-600:hover{
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity, 1));
}

.hover\\:from-blue-700:hover{
  --tw-gradient-from: rgb(var(--tw-blue-700, 29 78 216) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--tw-blue-700, 29 78 216) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-c-744fc0:hover{
  --tw-gradient-from: rgb(var(--c-744fc0, 116 79 192) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--c-744fc0, 116 79 192) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:from-green-700:hover{
  --tw-gradient-from: #15803d var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(21 128 61 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.hover\\:to-c-2f78bb:hover{
  --tw-gradient-to: rgb(var(--c-2f78bb, 47 120 187) / 1) var(--tw-gradient-to-position);
}

.hover\\:to-emerald-700:hover{
  --tw-gradient-to: #047857 var(--tw-gradient-to-position);
}

.hover\\:to-indigo-700:hover{
  --tw-gradient-to: rgb(var(--tw-indigo-700, 67 56 202) / 1) var(--tw-gradient-to-position);
}

.hover\\:text-agentic-accent-purple:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-accent-purple, 139 92 246) / var(--tw-text-opacity, 1));
}

.hover\\:text-agentic-primary-blue:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-primary-blue, 30 58 138) / var(--tw-text-opacity, 1));
}

.hover\\:text-agentic-primary-blue-dark:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-primary-blue-dark, 30 64 175) / var(--tw-text-opacity, 1));
}

.hover\\:text-agentic-text-primary:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-text-primary, 31 41 55) / var(--tw-text-opacity, 1));
}

.hover\\:text-agentic-text-secondary:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-text-secondary, 107 114 128) / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-500:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-blue-500, 59 130 246) / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-700:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-blue-700, 29 78 216) / var(--tw-text-opacity, 1));
}

.hover\\:text-blue-800:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-blue-800, 30 64 175) / var(--tw-text-opacity, 1));
}

.hover\\:text-c-4f5480:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--c-4f5480, 79 84 128) / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-600:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-gray-600, 75 85 99) / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-700:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--tw-gray-700, 55 65 81) / var(--tw-text-opacity, 1));
}

.hover\\:text-kv-agentic-blue:hover{
  --tw-text-opacity: 1;
  color: rgb(var(--kv-agentic-blue, 54 131 198) / var(--tw-text-opacity, 1));
}

.hover\\:text-red-500:hover{
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-600:hover{
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-700:hover{
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}

.hover\\:text-red-800:hover{
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}

.hover\\:text-white:hover{
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover{
  text-decoration-line: underline;
}

.hover\\:opacity-100:hover{
  opacity: 1;
}

.hover\\:opacity-70:hover{
  opacity: 0.7;
}

.hover\\:opacity-80:hover{
  opacity: 0.8;
}

.hover\\:opacity-90:hover{
  opacity: 0.9;
}

.hover\\:opacity-95:hover{
  opacity: 0.95;
}

.hover\\:shadow-lg:hover{
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-md:hover{
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-sm:hover{
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:shadow-xl:hover{
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:brightness-105:hover{
  --tw-brightness: brightness(1.05);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.focus\\:border-none:focus{
  border-style: none;
}

.focus\\:border-blue-500:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--tw-blue-500, 59 130 246) / var(--tw-border-opacity, 1));
}

.focus\\:border-c-8f8f8f:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-8f8f8f, 143 143 143) / var(--tw-border-opacity, 1));
}

.focus\\:border-kv-agentic-blue:focus{
  --tw-border-opacity: 1;
  border-color: rgb(var(--kv-agentic-blue, 54 131 198) / var(--tw-border-opacity, 1));
}

.focus\\:border-transparent:focus{
  border-color: transparent;
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-0:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-2:focus{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-agentic-primary-blue:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--agentic-primary-blue, 30 58 138) / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-100:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--tw-blue-100, 219 234 254) / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-200:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--tw-blue-200, 191 219 254) / var(--tw-ring-opacity, 1));
}

.focus\\:ring-blue-500:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--tw-blue-500, 59 130 246) / var(--tw-ring-opacity, 1));
}

.focus\\:ring-c-805dc6:focus{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--c-805dc6, 128 93 198) / var(--tw-ring-opacity, 1));
}

.focus\\:ring-kv-agentic-blue\\/20:focus{
  --tw-ring-color: rgb(var(--kv-agentic-blue, 54 131 198) / 0.2);
}

.focus-visible\\:outline-none:focus-visible{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus-visible\\:ring-2:focus-visible{
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-c-4f71ea:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--c-4f71ea, 79 113 234) / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-c-7f8ff2\\/80:focus-visible{
  --tw-ring-color: rgb(var(--c-7f8ff2, 127 143 242) / 0.8);
}

.focus-visible\\:ring-kv-agentic-blue:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--kv-agentic-blue, 54 131 198) / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-red-500:focus-visible{
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-white\\/90:focus-visible{
  --tw-ring-color: rgb(255 255 255 / 0.9);
}

.focus-visible\\:ring-offset-2:focus-visible{
  --tw-ring-offset-width: 2px;
}

.focus-visible\\:ring-offset-c-1f1f1f:focus-visible{
  --tw-ring-offset-color: rgb(var(--c-1f1f1f, 31 31 31) / 1);
}

.focus-visible\\:ring-offset-c-ece6f5:focus-visible{
  --tw-ring-offset-color: rgb(var(--c-ece6f5, 236 230 245) / 1);
}

.active\\:cursor-grabbing:active{
  cursor: grabbing;
}

.active\\:opacity-50:active{
  opacity: 0.5;
}

.disabled\\:pointer-events-none:disabled{
  pointer-events: none;
}

.disabled\\:cursor-not-allowed:disabled{
  cursor: not-allowed;
}

.disabled\\:bg-agentic-gray-100:disabled{
  --tw-bg-opacity: 1;
  background-color: rgb(var(--agentic-gray-100, 243 244 246) / var(--tw-bg-opacity, 1));
}

.disabled\\:text-agentic-text-muted:disabled{
  --tw-text-opacity: 1;
  color: rgb(var(--agentic-text-muted, 156 163 175) / var(--tw-text-opacity, 1));
}

.disabled\\:opacity-30:disabled{
  opacity: 0.3;
}

.disabled\\:opacity-40:disabled{
  opacity: 0.4;
}

.disabled\\:opacity-50:disabled{
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled{
  opacity: 0.6;
}

.group:hover .group-hover\\:pointer-events-auto{
  pointer-events: auto;
}

.group:hover .group-hover\\:-translate-y-0\\.5{
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-105{
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:scale-110{
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.group:hover .group-hover\\:bg-black\\/20{
  background-color: rgb(0 0 0 / 0.2);
}

.group:hover .group-hover\\:bg-black\\/40{
  background-color: rgb(0 0 0 / 0.4);
}

.group:hover .group-hover\\:text-c-0066cc{
  --tw-text-opacity: 1;
  color: rgb(var(--c-0066cc, 0 102 204) / var(--tw-text-opacity, 1));
}

.group:hover .group-hover\\:opacity-100{
  opacity: 1;
}

@media (min-width: 640px){

  .sm\\:-left-10{
    left: -2.5rem;
  }

  .sm\\:-left-8{
    left: -2rem;
  }

  .sm\\:left-8{
    left: 2rem;
  }

  .sm\\:mt-14{
    margin-top: 3.5rem;
  }

  .sm\\:mt-16{
    margin-top: 4rem;
  }

  .sm\\:mt-20{
    margin-top: 5rem;
  }

  .sm\\:mt-3{
    margin-top: 0.75rem;
  }

  .sm\\:mt-4{
    margin-top: 1rem;
  }

  .sm\\:mt-5{
    margin-top: 1.25rem;
  }

  .sm\\:h-10{
    height: 2.5rem;
  }

  .sm\\:h-11{
    height: 2.75rem;
  }

  .sm\\:h-14{
    height: 3.5rem;
  }

  .sm\\:h-\\[155px\\]{
    height: 155px;
  }

  .sm\\:h-\\[185px\\]{
    height: 185px;
  }

  .sm\\:h-\\[208px\\]{
    height: 208px;
  }

  .sm\\:h-\\[224px\\]{
    height: 224px;
  }

  .sm\\:min-h-\\[256px\\]{
    min-height: 256px;
  }

  .sm\\:w-10{
    width: 2.5rem;
  }

  .sm\\:w-11{
    width: 2.75rem;
  }

  .sm\\:w-\\[155px\\]{
    width: 155px;
  }

  .sm\\:w-\\[230px\\]{
    width: 230px;
  }

  .sm\\:w-\\[274px\\]{
    width: 274px;
  }

  .sm\\:w-\\[380px\\]{
    width: 380px;
  }

  .sm\\:max-w-\\[224px\\]{
    max-width: 224px;
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:gap-3{
    gap: 0.75rem;
  }

  .sm\\:self-auto{
    align-self: auto;
  }

  .sm\\:p-5{
    padding: 1.25rem;
  }

  .sm\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .sm\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:pb-12{
    padding-bottom: 3rem;
  }

  .sm\\:pt-10{
    padding-top: 2.5rem;
  }

  .sm\\:text-4xl{
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-5xl{
    font-size: 3rem;
    line-height: 1;
  }

  .sm\\:text-\\[2\\.15rem\\]{
    font-size: 2.15rem;
  }

  .sm\\:text-\\[2\\.4rem\\]{
    font-size: 2.4rem;
  }

  .sm\\:text-\\[2\\.5rem\\]{
    font-size: 2.5rem;
  }

  .sm\\:text-\\[2\\.8rem\\]{
    font-size: 2.8rem;
  }

  .sm\\:text-\\[2\\.9rem\\]{
    font-size: 2.9rem;
  }

  .sm\\:text-\\[3\\.5rem\\]{
    font-size: 3.5rem;
  }

  .sm\\:text-\\[4\\.75rem\\]{
    font-size: 4.75rem;
  }

  .sm\\:text-\\[4rem\\]{
    font-size: 4rem;
  }

  .sm\\:text-\\[5\\.3rem\\]{
    font-size: 5.3rem;
  }

  .sm\\:text-\\[6\\.5rem\\]{
    font-size: 6.5rem;
  }

  .sm\\:text-base{
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .sm\\:text-lg{
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-sm{
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-title-lg{
    font-size: 2rem;
    line-height: 1.2;
    font-weight: 600;
  }

  .sm\\:text-xl{
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 768px){

  .md\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .md\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .md\\:mt-16{
    margin-top: 4rem;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:h-12{
    height: 3rem;
  }

  .md\\:h-16{
    height: 4rem;
  }

  .md\\:h-\\[224px\\]{
    height: 224px;
  }

  .md\\:w-1\\/2{
    width: 50%;
  }

  .md\\:w-12{
    width: 3rem;
  }

  .md\\:w-56{
    width: 14rem;
  }

  .md\\:w-\\[36\\%\\]{
    width: 36%;
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:w-full{
    width: 100%;
  }

  .md\\:max-w-\\[160px\\]{
    max-width: 160px;
  }

  .md\\:max-w-\\[180px\\]{
    max-width: 180px;
  }

  .md\\:max-w-\\[220px\\]{
    max-width: 220px;
  }

  .md\\:max-w-\\[260px\\]{
    max-width: 260px;
  }

  .md\\:max-w-lg{
    max-width: 32rem;
  }

  .md\\:max-w-md{
    max-width: 28rem;
  }

  .md\\:max-w-sm{
    max-width: 24rem;
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-\\[1fr_220px\\]{
    grid-template-columns: 1fr 220px;
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:items-start{
    align-items: flex-start;
  }

  .md\\:items-end{
    align-items: flex-end;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:justify-between{
    justify-content: space-between;
  }

  .md\\:self-auto{
    align-self: auto;
  }

  .md\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .md\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .md\\:py-14{
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .md\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .md\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .md\\:pl-10{
    padding-left: 2.5rem;
  }

  .md\\:pt-14{
    padding-top: 3.5rem;
  }

  .md\\:text-left{
    text-align: left;
  }

  .md\\:text-3xl{
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .md\\:text-\\[3\\.4rem\\]{
    font-size: 3.4rem;
  }

  .md\\:text-display-xl{
    font-size: 3rem;
    line-height: 1.05;
    font-weight: 600;
  }
}

@media (min-width: 1024px){

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .lg\\:col-span-8{
    grid-column: span 8 / span 8;
  }

  .lg\\:mt-20{
    margin-top: 5rem;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:min-h-\\[300px\\]{
    min-height: 300px;
  }

  .lg\\:w-\\[300px\\]{
    width: 300px;
  }

  .lg\\:w-auto{
    width: auto;
  }

  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-\\[1fr_auto\\]{
    grid-template-columns: 1fr auto;
  }

  .lg\\:grid-cols-\\[280px\\2c minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: 280px minmax(0,1fr);
  }

  .lg\\:grid-cols-\\[380px_1fr\\]{
    grid-template-columns: 380px 1fr;
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_auto\\]{
    grid-template-columns: minmax(0,1fr) auto;
  }

  .lg\\:grid-cols-\\[minmax\\(0\\2c 420px\\)_minmax\\(0\\2c 1fr\\)\\]{
    grid-template-columns: minmax(0,420px) minmax(0,1fr);
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:items-start{
    align-items: flex-start;
  }

  .lg\\:items-end{
    align-items: flex-end;
  }

  .lg\\:items-center{
    align-items: center;
  }

  .lg\\:items-stretch{
    align-items: stretch;
  }

  .lg\\:justify-end{
    justify-content: flex-end;
  }

  .lg\\:justify-between{
    justify-content: space-between;
  }

  .lg\\:gap-6{
    gap: 1.5rem;
  }

  .lg\\:gap-8{
    gap: 2rem;
  }

  .lg\\:border-b-0{
    border-bottom-width: 0px;
  }

  .lg\\:border-l{
    border-left-width: 1px;
  }

  .lg\\:border-r{
    border-right-width: 1px;
  }

  .lg\\:border-t-0{
    border-top-width: 0px;
  }

  .lg\\:border-solid{
    border-style: solid;
  }

  .lg\\:border-c-e3e7f3{
    --tw-border-opacity: 1;
    border-color: rgb(var(--c-e3e7f3, 227 231 243) / var(--tw-border-opacity, 1));
  }

  .lg\\:p-12{
    padding: 3rem;
  }

  .lg\\:p-6{
    padding: 1.5rem;
  }

  .lg\\:px-0{
    padding-left: 0px;
    padding-right: 0px;
  }

  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:py-0{
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .lg\\:py-16{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .lg\\:pb-2{
    padding-bottom: 0.5rem;
  }

  .lg\\:pr-6{
    padding-right: 1.5rem;
  }

  .lg\\:text-2xl{
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .lg\\:text-7xl{
    font-size: 4.5rem;
    line-height: 1;
  }

  .lg\\:text-\\[3\\.5rem\\]{
    font-size: 3.5rem;
  }

  .lg\\:text-\\[3\\.75rem\\]{
    font-size: 3.75rem;
  }

  .lg\\:text-\\[3rem\\]{
    font-size: 3rem;
  }

  .lg\\:text-\\[6\\.1rem\\]{
    font-size: 6.1rem;
  }
}

@media (min-width: 1280px){

  .xl\\:sticky{
    position: sticky;
  }

  .xl\\:top-4{
    top: 1rem;
  }

  .xl\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .xl\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .xl\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }

  .xl\\:flex{
    display: flex;
  }

  .xl\\:hidden{
    display: none;
  }

  .xl\\:max-h-\\[calc\\(100dvh-20rem\\)\\]{
    max-height: calc(100dvh - 20rem);
  }

  .xl\\:w-72{
    width: 18rem;
  }

  .xl\\:max-w-\\[1466px\\]{
    max-width: 1466px;
  }

  .xl\\:shrink-0{
    flex-shrink: 0;
  }

  .xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_360px\\]{
    grid-template-columns: minmax(0,1fr) 360px;
  }

  .xl\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_560px\\]{
    grid-template-columns: minmax(0,1fr) 560px;
  }

  .xl\\:flex-row{
    flex-direction: row;
  }

  .xl\\:items-start{
    align-items: flex-start;
  }

  .xl\\:gap-8{
    gap: 2rem;
  }

  .xl\\:self-start{
    align-self: flex-start;
  }
}

@media (prefers-color-scheme: dark){

  .dark\\:border-gray-700{
    --tw-border-opacity: 1;
    border-color: rgb(var(--tw-gray-700, 55 65 81) / var(--tw-border-opacity, 1));
  }

  .dark\\:bg-gray-800{
    --tw-bg-opacity: 1;
    background-color: rgb(var(--tw-gray-800, 31 41 55) / var(--tw-bg-opacity, 1));
  }

  .dark\\:hover\\:bg-gray-700:hover{
    --tw-bg-opacity: 1;
    background-color: rgb(var(--tw-gray-700, 55 65 81) / var(--tw-bg-opacity, 1));
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,uCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,uCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,sDAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+EAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,2DAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,+CAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;IAAA,0GAAc;IAAd,kCAAc;IAAd,mCAAc;IAAd,kCAAc;EAAA;;EAAd;EAAA,kBAAc;EAAd,kFAAc;EAAd,oBAAc;EAAd,6EAAc;IAAd;AAAc;;EAAd;EAAA,8BAAc;EAAd,mBAAc;EAAd,2GAAc;EAAd,yGAAc;EAAd,4FAAc;EAAd,oBAAc;EAAd,wFAAc;EAAd;AAAc;;EAAd;IAAA,UAAc;IAAd,WAAc;EAAA;;EAAd;EAAA,kBAAc;EAAd;AAAc;;EAAd;EAAA,qBAAc;EAAd,kBAAc;EAAd;AAAc;;EAAd;EAAA,kBAAc;EAAd;AAAc;AACd;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;;EA6DhB;EAAA,kBAAwE;EAAxE,gBAAwE;EAAxE,mBAAwE;EAAxE,kBAAwE;EAAxE,oBAAwE;EAAxE;AAAwE;;EAIxE;EAAA,iBAAqE;EAArE,iBAAqE;EAArE,gBAAqE;EAArE,iBAAqE;EAArE,oBAAqE;EAArE;AAAqE;;EAYrE;EAAA,wBAAgH;EAAhH,yBAAgH;EAAhH,qBAAgH;EAAhH,sBAAgH;EAAhH,iBAAgH;EAAhH,oBAAgH;EAAhH,mBAAgH;EAAhH,oBAAgH;EAAhH,gBAAgH;EAAhH,oBAAgH;EAAhH,kFAAgH;EAAhH,+FAAgH;EAAhH,wDAAgH;EAAhH;AAAgH;;EAChH;EAAA,sBAAoE;EAApE,qFAAoE;EAApE,oBAAoE;EAApE;AAAoE;;EAIpE;EAAA,sBAA4D;EAA5D,uFAA4D;EAA5D,oBAA4D;EAA5D;AAA4D;;EAI5D;EAAA,qBAA4D;EAA5D,iBAA4D;EAA5D,sBAA4D;EAA5D,qFAA4D;EAA5D,kBAA4D;EAA5D;AAA4D;;EAe5D;EAAA,cAA+E;EAA/E;AAA+E;;EAA/E;;EAAA;IAAA;EAA+E;AAAA;;EAA/E;EAAA,kCAA+E;EAA/E,qBAA+E;EAA/E,wBAA+E;EAA/E,sBAA+E;EAA/E;AAA+E;AApGnF;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA,2BAAmB;IAAnB;EAAmB;;EAAnB;IAAA,eAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,gEAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oCAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sGAAmB;EAAnB,kGAAmB;EAAnB;AAAmB;AAAnB;EAAA,oGAAmB;EAAnB,gGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sGAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB,+FAAmB;EAAnB;AAAmB;AAAnB;EAAA,mGAAmB;EAAnB,+FAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,6FAAmB;EAAnB,yFAAmB;EAAnB;AAAmB;AAAnB;EAAA,4FAAmB;EAAnB,wFAAmB;EAAnB;AAAmB;AAAnB;EAAA,4FAAmB;EAAnB,wFAAmB;EAAnB;AAAmB;AAAnB;EAAA,4FAAmB;EAAnB,wFAAmB;EAAnB;AAAmB;AAAnB;EAAA,2FAAmB;EAAnB,uFAAmB;EAAnB;AAAmB;AAAnB;EAAA,uFAAmB;EAAnB,mFAAmB;EAAnB;AAAmB;AAAnB;EAAA,yFAAmB;EAAnB,qFAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4FAAmB;EAAnB,wFAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,8FAAmB;EAAnB,0FAAmB;EAAnB;AAAmB;AAAnB;EAAA,kGAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,8FAAmB;EAAnB,0FAAmB;EAAnB;AAAmB;AAAnB;EAAA,8FAAmB;EAAnB,0FAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,4DAAmB;EAAnB,oEAAmB;EAAnB;AAAmB;AAAnB;EAAA,yDAAmB;EAAnB,qEAAmB;EAAnB;AAAmB;AAAnB;EAAA,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,0FAAmB;EAAnB;AAAmB;AAAnB;EAAA,qFAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sEAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,2DAAmB;EAAnB,qDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2DAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2DAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wDAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,qDAAmB;EAAnB,mDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2DAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2DAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,0DAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,2CAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2DAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,mKAAmB;EAAnB,mEAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;;;;;;;EAOE;;AA+FF;;EAEE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;;;wFAGwF;AACxF;EACE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;EAC1B,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;EACd,kBAAkB;EAClB,wDAAwD;AAC1D;;AA5KA;EAAA,mBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,sBA6KA;EA7KA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA,2GA6KA;EA7KA,yGA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA,0BA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,iBA6KA;EA7KA,iBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,sBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,sBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,sBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,sBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,sBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,sBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,sBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,sBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,sBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,2FA6KA;EA7KA,uFA6KA;EA7KA;AA6KA;;AA7KA;EAAA,yFA6KA;EA7KA,qFA6KA;EA7KA;AA6KA;;AA7KA;EAAA,4DA6KA;EA7KA,mEA6KA;EA7KA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA,+EA6KA;EA7KA,mGA6KA;EA7KA;AA6KA;;AA7KA;EAAA,6EA6KA;EA7KA,iGA6KA;EA7KA;AA6KA;;AA7KA;EAAA,0CA6KA;EA7KA,uDA6KA;EA7KA;AA6KA;;AA7KA;EAAA,gFA6KA;EA7KA,oGA6KA;EA7KA;AA6KA;;AA7KA;EAAA,iCA6KA;EA7KA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA,sBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,sBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,sBA6KA;EA7KA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA,8BA6KA;EA7KA;AA6KA;;AA7KA;EAAA,2GA6KA;EA7KA,yGA6KA;EA7KA;AA6KA;;AA7KA;EAAA,2GA6KA;EA7KA,yGA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA,8BA6KA;EA7KA;AA6KA;;AA7KA;EAAA,2GA6KA;EA7KA,yGA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA,2BA6KA;EA7KA;AA6KA;;AA7KA;EAAA,kBA6KA;EA7KA,kBA6KA;EA7KA;AA6KA;;AA7KA;EAAA,iBA6KA;EA7KA,iBA6KA;EA7KA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;EAAA,oBA6KA;EA7KA;AA6KA;;AA7KA;EAAA;AA6KA;;AA7KA;;EAAA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA,iBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,kBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,oBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,kBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,mBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,iBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,iBA6KA;IA7KA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA,kBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,eA6KA;IA7KA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA,eA6KA;IA7KA;EA6KA;;EA7KA;IAAA,mBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,mBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,eA6KA;IA7KA,gBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,kBA6KA;IA7KA;EA6KA;AAAA;;AA7KA;;EAAA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA,kBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,mBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,iBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,mBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,oBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,mBA6KA;IA7KA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA,mBA6KA;IA7KA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA,eA6KA;IA7KA,iBA6KA;IA7KA;EA6KA;AAAA;;AA7KA;;EAAA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA,sBA6KA;IA7KA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA,iBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,kBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,gBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,iBA6KA;IA7KA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA,iBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,iBA6KA;IA7KA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;AAAA;;AA7KA;;EAAA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA,iBA6KA;IA7KA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;;EA7KA;IAAA;EA6KA;AAAA;;AA7KA;;EAAA;IAAA,sBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,kBA6KA;IA7KA;EA6KA;;EA7KA;IAAA,kBA6KA;IA7KA;EA6KA;AAAA","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Afacad:wght@400;500;600&family=Golos+Text:wght@400;600&family=Outfit:wght@300;400;500;600;700;800&display=swap');\n\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/*\n * Theme.\n *\n * Every colour class reads a CSS custom property with today's colour as its\n * fallback (see tailwind.config.js and src/theme/tokens.json). The theme engine\n * (src/theme/engine.ts) sets those properties from the tenant's or product's\n * colours; when nothing is set, the fallbacks apply and nothing changes.\n */\n\n@layer base {\n  html {\n    font-family: var(--theme-font-family, 'Outfit', 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif);\n    text-rendering: geometricPrecision;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n  }\n\n  body {\n    @apply bg-agentic-white text-agentic-text-primary;\n    font-feature-settings: 'cv02', 'cv03', 'cv04', 'cv11';\n  }\n\n  *:focus {\n    @apply outline-none ring-2 ring-agentic-primary-blue ring-offset-2;\n  }\n\n  ::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n  }\n\n  ::-webkit-scrollbar-track {\n    @apply bg-agentic-gray-100;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    @apply rounded-full bg-agentic-gray-300;\n  }\n\n  ::-webkit-scrollbar-thumb:hover {\n    @apply bg-agentic-gray-400;\n  }\n}\n\n@layer components {\n  .card-title {\n    @apply text-xl font-semibold text-agentic-text-primary;\n  }\n\n  .card-subtitle {\n    @apply mt-1 text-sm text-agentic-text-secondary;\n  }\n\n  .page-title {\n    @apply text-display-lg text-kv-agentic-body;\n  }\n\n  .page-subtitle {\n    @apply mt-2 max-w-3xl text-body-lg leading-relaxed text-kv-agentic-slate;\n  }\n\n  .section-title {\n    @apply text-2xl font-semibold leading-tight text-agentic-text-primary;\n  }\n\n  .field-label {\n    @apply text-sm font-medium text-agentic-text-secondary;\n  }\n\n  .field-value {\n    @apply text-lg font-medium leading-snug text-agentic-text-primary;\n  }\n\n  .tab-title {\n    @apply border-b-2 border-transparent px-1 py-4 text-sm font-medium text-agentic-text-secondary transition-colors;\n    @apply hover:border-agentic-gray-300 hover:text-agentic-text-primary;\n  }\n\n  .tab-title-active {\n    @apply border-agentic-primary-blue text-agentic-primary-blue;\n  }\n\n  .tab-content-panel {\n    @apply rounded-panel border border-agentic-gray-200 bg-white;\n  }\n\n  .form-input {\n    @apply w-full rounded-md border border-agentic-gray-300 px-4 py-3;\n    @apply placeholder-agentic-text-muted transition-all duration-300 ease-agentic;\n    @apply focus:border-agentic-primary-blue focus:ring-1 focus:ring-agentic-primary-blue;\n    min-height: 44px;\n  }\n\n  .form-label {\n    @apply mb-2 block text-sm font-medium text-agentic-text-primary;\n  }\n\n  .loading-spinner {\n    @apply h-6 w-6 animate-spin rounded-full border-b-2 border-agentic-primary-blue;\n  }\n}\n\n.message-content ol,\n.message-content ul {\n  list-style: revert;\n  margin-left: 1.5em;\n}\n\n.message-content h1,\n.message-content h2 {\n  color: rgb(var(--c-1a1a1a, 26 26 26));\n  font-weight: 700;\n  margin-bottom: 20px;\n}\n\n.message-content h1 {\n  font-size: 1.4rem;\n  line-height: 1.4;\n}\n\n.message-content h2 {\n  font-size: 1.2rem;\n  line-height: 1.4;\n}\n\n.message-content p {\n  margin-bottom: 16px;\n  font-size: 0.95rem;\n}\n\n.message-content ul {\n  margin: 12px 0;\n  padding-left: 20px;\n}\n\n.message-content ul li {\n  margin-bottom: 8px;\n}\n\n.message-content strong {\n  font-weight: 600;\n  color: rgb(var(--agentic-primary-blue, 30 58 138));\n}\n\n/* `color: inherit` (not the fixed brand blue used for `strong`) deliberately — this class is\n * shared by both the bot's white bubble and the user's own colored/gradient bubble, and a fixed\n * color reads fine on white but loses contrast against a colored bubble. Underline + bold weight\n * alone is enough to read as a link against either background, with no contrast risk. */\n.message-content a {\n  color: inherit;\n  font-weight: 600;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  word-break: break-word;\n}\n\n.message-content a:hover {\n  opacity: 0.75;\n}\n\n.message-content blockquote {\n  font-style: italic;\n  color: rgb(var(--c-555555, 85 85 85));\n  margin: 20px 0;\n  padding-left: 20px;\n  border-left: 4px solid rgb(var(--c-cccccc, 204 204 204));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
